import { Icon } from "@iconify/react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  Steps,
  Typography,
  Upload,
  UploadFile,
  UploadProps,
  Checkbox,
  Image,
  DatePicker,
  InputNumber,
  Select,
  Modal,
  message,
  Radio,
  Popover,
  Tooltip,
  Spin,
} from "antd";
import { useState, ReactNode, useCallback, useEffect, useRef } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import * as yup from "yup";
import { ContentWrapper, DataTable, WrapperCard, PDFViewer, PDFView } from "~/Components";
import styles from "../../SPA.module.scss";
import { ErrorMessage, Field, FieldProps, Formik, FormikTouched, useFormik, useFormikContext } from "formik";
import { useAuth } from "~/Hooks/useAuth";
import { filter, map, some, values } from "lodash";
import { useNotification } from "~/Hooks/useNotification";
import moment from "moment";
import upload from "@assets/SVG/upload.svg";
import { api, get, post, put, remove } from "@services/api.service";
import { numberToWord } from "~/Utils/CommonUtils";
import { currencyOptions } from "~/Utils/CurrenyOptions";
import { currencyData } from "~/Utils/CurrencyCodes";
import { scrollToElement } from "~/Utils/CommonUtils";
import {
  currency,
  subsidiaries,
  taxList,
  designation,
  department,
  mdReviewer,
  gcfoReviewer,
  headSubsidiary,
  budget,
  deaprtmentRoles,
  spaBudget,
  spaPaper,
  airportDesignation,
  nonAirportDesignation,
} from "~/Utils/StringConstants";
import { allowedDomainsAll, currencyFormat, defaultCurrencyCode, procurementProcess } from "~/Utils";
import { LoaderModal } from "~/Components/LoaderModal/LoaderModal";
import { useQuery } from "~/Hooks/useQuery";
import { SpaReviewForm } from "~/Components/SpaForm/SpaForm";
import Item from "antd/lib/list/Item";
import React from "react";
import { docVersionKey } from "~/Utils";
import RichTextInput from "~/Components/TextEditor/textEditor";
import pdfMake from "pdfmake/build/pdfmake";
import { get as _get } from "lodash";
import { printPdf } from "~/Utils/pdfmake/generate-pdf";

interface FormItems {
  paperDrop: string;
  budgetDrop: string;
  name: string;
  touched: any;
  reviewerSigningOrder: boolean;
  signerSigningOrder: boolean;
  vendorSigningOrder: boolean;
  lhdnSigningOrder: boolean;
  signers: {
    designation: any;
    name: string;
    email: string;
    division: string;
    subsidiary: string;
    routingOrder: string;
  }[];
  oneCenter: {
    designation: any;
    name: string;
    email: string;
    routingOrder: string;
  }[];
  watchers: {
    role: string;
    userName: string;
    userEmail: string;
  }[];
  watcherOne: {
    role: string;
    userName: string;
    userEmail: string;
  };
  reviewers: {
    desgination: string;
    name: string;
    email: string;
    routingOrder?: string;
    isR1: boolean;
  }[];
  vendors: {
    name: string;
    email: string;
  }[];
  lhdnSigner: {
    name: string;
    email: string;
  }[];
  currency: {
    currencyCode: string;
    totalCost: string;
  };
  currencyCode: string;
  totalCost: string;
  category: string;
  remark: string;
  vendorName: string;
  reviewerName: string;
  reviewerEmail: string;
  commencementDate: string;
  completionDate: string;
  templateId: string;
  contractNumber: string;
  templateName: string;
  templateDescription: string;
  projectTitle: string;
  status: string;
  budget: string;
  awardAndStrategyPaper: string;
  // emailSubject: string;
  // emailMessage: string;
  projectSummary: string;
  procurementSummary: string;
  recommendedVendor: string;
  renewalReminderNotification: string;
  reminderEnabled: boolean;
  reminderFrequency: string;
  reminderDelay: string;
  expiryAfter: string;
  expiryOn: string;
  expiryWarn: string;
  subsidiary: string;
  // signerCanSignOnMobile: boolean;
  messageLock: boolean;
  oneCenterEnable: boolean;
  procurementProcess: string;
  allowComments: boolean;
  contractValue: string;
  contractPeriod: string;
  division: string;
  designation: string;
  additionaldocument: { name: string; url: string }[];
  documentLinkDetails: { name: string; url: string }[];
}

interface SignerItemProps {
  index: number;
  moveSigner: (from: number, to: number) => void;
  values: FormItems;
  setValues: (values: FormItems) => void;
}

const defaultValue = {
  name: "",
  signers: [
    {
      name: "",
      email: "",
      designation: "",
      division: "",
      subsidiary: "",
      routingOrder: "1",
    },
  ],

  oneCenter: [
    {
      name: "",
      email: "",
      // designation: "",
      // department: "",
      routingOrder: "2",
    },
  ],
  watchers: [
    {
      role: "",
      userName: "",
      userEmail: "",
    },
    {
      role: "",
      userName: "",
      userEmail: "",
    },
    {
      role: "",
      userName: "",
      userEmail: "",
    },
  ],
  watcherOne: {
    role: "",
    userName: "",
    userEmail: "",
  },
  reviewers: [
    {
      designation: "",
      name: "",
      email: "",
      routingOrder: "",
    },
  ],
  vendors: [
    {
      name: "",
      email: "",
    },
    {
      name: "",
      email: "",
    },
  ],
  lhdnSigner: [
    {
      name: "",
      email: "",
    },
    {
      name: "",
      email: "",
    },
  ],
  currency: {
    currencyCode: "",
    // totalCost: 0,
  },
  contractValue: "",
  remark: "",
  currencyCode: defaultCurrencyCode,
  totalCost: "0",
  category: "",
  division: "",
  projectSummary: "",
  vendorName: "",
  expiryOn: "",
  templateId: "",
  templateName: "",
  templateDescription: "",
  projectTitle: "",
  commencementDate: "",
  completionDate: "",
  oneCenterEnable: false,
  contractNumber: "",
  contractPeriod: "",
  renewalReminderNotification: "",
  // emailSubject: "",
  // emailMessage: "",
  recommendedVendor: "",
  procurementSummary: "",
  reminderEnabled: false,
  procurementProcess: "1d",
  reminderFrequency: "",
  reminderDelay: "",
  expiryAfter: "",
  expiryWarn: "",
  subsidiary: "",
  status: "",
  budget: "",
  awardAndStrategyPaper: "",
  // signerCanSignOnMobile: false,
  vendorSigningOrder: false,
  lhdnSigningOrder: false,
  messageLock: false,
  allowComments: true,
  designation: "",
  additionaldocument: [
    {
      url: "",
    },
  ],
  documentLinkDetails: [
    {
      name: "",
      url: "",
    },
  ],
} as unknown as FormItems;

const isHtmlString = (val: any) => typeof val === "string" && /<\/?[a-z][\s\S]*>/i.test(val);

const getItemText = (name?: string, value?: any, className = "", isBoolean?: any, style = {}) => {
  if (value === "Invalid date") value = "-";
  return (
    <Space
      direction="vertical"
      style={{ marginBottom: styles.whitespace4, fontWeight: 100 }}
      className={className}
    >
      <h3 style={{ color: "#29256E" }}>{name}</h3>
      <div style={{ color: "black" }}>
        {!isBoolean ? (
          Array.isArray(value) ? (
            value.map((doc, index) => (
              <Typography.Text
                key={index}
                type="secondary"
                style={{ display: "block" }}
              >
                {`${doc.url}`}
              </Typography.Text>
            ))
          ) : isHtmlString(value) ? (
            <div
              className="ck-content"
              dangerouslySetInnerHTML={{ __html: value }}
            />
          ) : (
            <Typography.Text>{value}</Typography.Text>
          )
        ) : value === "true" ? (
          <Typography.Text type="secondary">Enabled</Typography.Text>
        ) : (
          <Typography.Text type="secondary">Disabled</Typography.Text>
        )}
      </div>
    </Space>
  );
};
const EqualCol = ({ children }: { children: ReactNode }) => (
  <Col
    xs={24}
    md={12}
  >
    {children}
  </Col>
);

var newDocId = 100;

export const AddNewSPA = () => {
  const [docsList, setDocsList] = useState<any>([]); // contains all files
  const [record, setRecord] = useState<any>({});
  const { user } = useAuth();
  const [isSubmitLoading, setSubmitLoading] = useState(false);
  const { openNotification } = useNotification();
  const [currentStep, setCurrentStep] = useState(0);
  const [isloading, setIsLoading] = useState(false);
  const [templateId, setTemplateId] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [initialValues, setInitialValues] = useState<FormItems>(defaultValue);
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [open, setOpen] = useState(false);
  const [selectedPoints, setSelectedPoints] = useState<string>("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [loadingDocId, setLoadingDocId] = useState<string>("");
  const [selectCurCode, setSelectCurCode] = useState([currency]);
  const [deletedIds, setDeletedIds] = useState<any>([]);
  const [subsidiaryName, setSubsidiaryName] = useState("");
  const [spaSubsidiaryName, setSpaSubsidiaryName] = useState("");
  const [selectRole, setSelectRole] = useState("");
  const [newEnvelopeID, setNewEnvelopeId] = useState<any>();
  const [scale, setScale] = useState<number>(1);
  const [loaderModal, setLoaderModal] = useState<boolean>(false);
  const [selectedEmails, setSelectedEmails] = useState<string[]>([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [draftApprovalAuthority, setDraftApprovalAuthority] = useState<string | null>(null);
  const [selectDocument, setSelectDocument] = useState<FormItems | null>();
  const [selectedDocument, setSelectedDocument] = useState<string>("");
  const [selectedDocumentReview, setSelectedDocumentReview] = useState<string>("");
  const [divisionName, setDivisionName] = useState("");
  const [spaDivisionName, setSpaDivisionName] = useState("");
  const [subsidiaryData, setSubsidiaryData] = useState([]);
  const [divisionData, setDivisionData] = useState([]);
  const [spadivisionData, setSpaDivisionData] = useState([]);
  const [approverData, setApproverData] = useState([]);
  const [totalFiles, setTotalFiles] = useState<number>(0);
  const [subsidiaryId, setSubsidiaryId] = useState("");
  const [spaSubsidiaryId, setSpaSubsidiaryId] = useState("");
  const [filesUploadedCount, setFilesUploadedCount] = useState<number>(0);
  const [selectedDesignation, setSelectedDesignation] = useState<any>([]);
  const [signerDetail, setSignerDetail] = useState<any>([]);
  const [approverDetails, setApproverDetails] = useState<any>([]);
  const [defaultDivisionName, setDefaultDivisionName] = useState<any>("");
  const [paperValue, setPaperValue] = useState<any>("");
  const [budgetValue, setBudgetValue] = useState<any>("");
  const [approverBudget, setapproverBudget] = useState<any>("");
  const [reviewersInitialized, setReviewersInitialized] = useState(false);
  const [watchers, setWatchers] = useState<any>([]);
  const [formattedCost, setFormattedCost] = useState<any>({});
  const [totalVersion, setTotalVersion] = useState<number>(0);
  const [data, setData] = useState<{ [key in string]: any }>({});
  const { id } = useParams();
  const querry = useQuery();
  const [isDraftSaved, setIsDraftSaved] = useState(false);
  const [isUploadTouched, setIsUploadTouched] = useState(false);
  const [createdFile, setCreatedFile] = useState<any>([]);
  const [updatedFile, setUpdatedFile] = useState<any>([]);
  const [documents, setDocuments] = useState<any>([]);
  const [subsidiaryDraft, setSubsidiaryDraft] = useState<any>([]);
  const [costValue, setCostValue] = useState<any>(0);
  const pathname = location.pathname;
  const displaySave = pathname.includes("add");
  const isAirportManager = selectRole === "airportManager";
  const [isApproverApiFailed, setIsApproverApiFailed] = useState(false);

  const getPdfData = async (values: any) => {
    let logs = await get(`v1/auditlog/envelope/get-all-logs?envelopeId=${values?.overAllData?.envelopeId}`);
    let docVersion = await get(
      `v1/spa/get/document/versions?envelopeId=${values?.overAllData?.envelopeId}&order=desc&orderBy=updatedOn`
    );
    let comments = await get(
      `v1/workflow/getCommentsList?envelopeId=${values?.overAllData?.envelopeId}&order=desc&orderBy=commentedOn`
    );
    return {
      data: values.overAllData,
      reviewers: values.overAllReviewers || [],
      watchers: values.overAllWatchers || [],
      documents: values?.overAllData?.documentVersionResponses || [],
      logs: _get(logs, "response.data.records", []),
      docVersion: _get(docVersion, "response.data", []),
      comments: _get(comments, "response.data.records", []),
    };
  };

  const getPdfBlobFromDocDefinition = (docDefinition: any): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).getBlob((blob: Blob) => {
          resolve(blob);
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  const createPdfFile = (blob: Blob, fileName: string): File => {
    return new File([blob], fileName, {
      type: "application/pdf",
      lastModified: Date.now(),
    });
  };

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      if (file instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(file as Blob);
        reader.onload = () => resolve(reader.result);
        ``;
        reader.onerror = (error) => reject(error);
      } else {
        resolve({});
      }
    });
  };
  const envelopId: any = querry.get("envelopId");
  useEffect(() => {
    if (envelopId) {
      getEnvelopeDetails();
      getReviewers();
      getWatchers();
      getFullDetails();
    }
  }, [envelopId]);
  const step1Function = () => {
    setCurrentStep(0);
    scrollToElement("step1");
  };
  const step2Function = () => {
    setCurrentStep(1);
    scrollToElement("step1");
  };

  const stepAdditionalDocFunction = () => {
    setCurrentStep(1);
    scrollToElement("documentLinks");
  };

  const stepBudgetFunction = () => {
    scrollToElement("step2");
    setCurrentStep(2);
  };

  const stepOneStopFunction = () => {
    setCurrentStep(2);
    scrollToElement("oneStop");
  };

  const stepApproverFunction = () => {
    setCurrentStep(2);
  };

  const stepWatcherFunction = () => {
    setCurrentStep(3);
  };
  const getFullDetails = () => {
    setIsLoading(true);
    get(`v1/spa/get/documents/current-version?envelopeId=${envelopId}`)
      .then((res: any) => {
        setIsLoading(false);
        if (res.response.data) {
          setDocuments(res.response.data);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const createPayload = (
    values: any,
    subsidiaryName: string,
    selectedPoints: any,
    defaultCurrencyCode: string,
    oneCenterEnable: boolean,
    initialBudget: string,
    initialPaper: string
  ) => {
    const allowedReviewerKeys = ["name", "email", "designation", "division", "subsidiary", "routingOrder"];
    let routingOrderCounter = 1;
    let watchers = values?.watchers.map((watcher: any) => {
      const { department, name, email, ...rest } = watcher;
      return rest;
    });

    let signers = values?.signers.map((signer: any, index: number) => {
      const { department, ...rest } = signer;
      return { ...rest, subsidiary: subsidiaryName, routingOrder: routingOrderCounter++ };
    });

    let maxRoutingOrder = signers.length;

    let oneCenter = oneCenterEnable
      ? values?.oneCenter.map((signer: any, index: number) => {
        const { ...rest } = signer;
        return { ...rest, routingOrder: routingOrderCounter };
      })
      : [];

    if (oneCenter.length > 0) routingOrderCounter++;

    const allReviewers = values?.reviewers || [];
    const reviewersByDesignation: Record<string, any[]> = {};
    const designationOrder: string[] = [];
    allReviewers.forEach((rev: any) => {
      if (!rev?.designation || !rev?.email) return;

      const isSigner = signers.some((s: any) => s.email === rev.email && s.designation === rev.designation);
      if (isSigner) return;

      const key = rev.designation;
      if (!reviewersByDesignation[key]) {
        reviewersByDesignation[key] = [];
        designationOrder.push(key);
      }
      const alreadyExists = reviewersByDesignation[key].some((r) => r.email === rev.email);
      if (!alreadyExists) reviewersByDesignation[key].push(rev);
    });

    const finalReviewers: any[] = [];

    const airportManagerOrderMap: any = {
      "APC SECRETARIAT": 2,
      "APC MEMBER": 3,
      "AIRPORT MANAGER": 4,
    };

    if (selectRole === "airportManager") {
      Object.keys(airportManagerOrderMap).forEach((designation) => {
        if (reviewersByDesignation[designation]) {
          finalReviewers.push(
            ...reviewersByDesignation[designation].map((rev: any) => ({
              ...rev,
              routingOrder: airportManagerOrderMap[designation],
            }))
          );
          designationOrder.splice(designationOrder.indexOf(designation), 1);
          delete reviewersByDesignation[designation];
        }
      });
    }

    if (reviewersByDesignation["R1"]) {
      finalReviewers.push(
        ...reviewersByDesignation["R1"].map((rev: any) => ({
          ...rev,
          routingOrder: routingOrderCounter,
        }))
      );
      routingOrderCounter++;
      designationOrder.splice(designationOrder.indexOf("R1"), 1);
      delete reviewersByDesignation["R1"];
    }

    designationOrder.forEach((designation) => {
      finalReviewers.push(
        ...reviewersByDesignation[designation].map((rev: any) => ({
          ...rev,
          routingOrder: routingOrderCounter,
        }))
      );
      routingOrderCounter++;
    });

    const cleanedReviewers = [...signers, ...oneCenter, ...finalReviewers].map((reviewer) => {
      return Object.fromEntries(Object.entries(reviewer).filter(([key]) => allowedReviewerKeys.includes(key)));
    });
    let totalCost = values?.totalCost && values?.totalCost.replace(/,/g, "");
    let payload: any = {
      templateId: values.templateId,
      templateName: values.templateName,
      projectTitle: values.projectTitle,
      procurementNumber: selectedPoints,
      projectSummary: values.projectSummary,
      subsidiary: subsidiaryName,
      division: values.division,
      procurementSummary: values.procurementSummary,
      recommendedVendor: values.recommendedVendor,
      contractValue: values.contractValue,
      contractPeriod: values.contractPeriod,
      approvalAuthority: selectRole,
      budget: initialBudget,
      awardAndStrategyPaper: initialPaper,
      reminders: {
        reminderFrequency: values.reminderFrequency,
        reminderDelay: values.reminderDelay,
        reminderEnabled: values.reminderEnabled,
      },
      expirations: {
        expiryWarn: values.expiryWarn,
        expiryAfter: values.expiryAfter,
        expiryEnabled: true,
      },
      currency: {
        currencyCode: values.currencyCode || defaultCurrencyCode,
        totalCost: totalCost,
        tax: values.tax,
      },
      status: "draft",
      documentLinkDetails: values?.documentLinkDetails,
    };
    if (cleanedReviewers.length > 0) {
      payload.reviewers = cleanedReviewers;
    }

    if (watchers?.length > 0) {
      if (watchers[0]?.userEmail != "") {
        payload.watchers = [...watchers];
      }
    }
    return payload;
  };
  const handleFileChange = async (info: any, isUpdated = false) => {
    const { file } = info;
    try {
      const getNumberedFileName = (originalName: string, existingFiles: any[] | null) => {
        const lastDotIndex = originalName.lastIndexOf(".");
        const baseName = lastDotIndex !== -1 ? originalName.substring(0, lastDotIndex) : originalName;
        if (!existingFiles?.some((f) => f.name === baseName)) {
          return baseName;
        }
        let counter = 1;
        let newName = `${baseName}(${counter})`;
        while (existingFiles?.some((f) => f.name === newName)) {
          counter++;
          newName = `${baseName}(${counter})`;
        }

        return newName;
      };
      const fileName = getNumberedFileName(file.name, docsList);
      const base64String: any = await convertToBase64(file);
      const documentBase64 = base64String.toString().split(",")[1];
      const renamedFile = new File([file], fileName, { type: file.type });

      const newFile = {
        documentBase64: documentBase64,
        documentId: `${newDocId}`,
        fileExtension: file.name.split(".").pop() || file.type?.split("/")[1],
        name: fileName,
        isNew: true,
        file: renamedFile,
      };
      if (docsList == null || docsList?.length < 10) {
        setDocsList((prevList: any) => [...(prevList || []), newFile]);
      } else {
        message.error("Adding the file exceeds the limit");
      }
      if (!isUpdated && newFile.isNew) {
        setUpdatedFile((prevList: any) => [...prevList, newFile]);
      } else {
        setCreatedFile((prevList: any) => [...prevList, newFile]);
      }
      setDocuments((prevList: any) => [...prevList, newFile]);
    } catch (error) {
      console.error("Error converting file to base64:", error);
    }
  };

  const saveAsDraft = async (values: any) => {
    const initialBudget = values?.budgetDrop || values?.budget;
    const initialPaper = values?.paperDrop || values?.awardAndStrategyPaper;
    const payload = createPayload(
      values,
      subsidiaryName,
      selectedPoints,
      defaultCurrencyCode,
      oneCenterEnable,
      initialBudget,
      initialPaper
    );
    const formData = new FormData();
    formData.append("body", JSON.stringify(payload));
    formData.append("templateId", values?.templateId);
    const generateRandomUADId = () => Math.floor(Math.random() * 1000000000).toString();
    const versionKey = generateRandomUADId();

    try {
      if (envelopId) {
        try {
          const nextVersionOrder = 1;
          await put(
            `v1/workflow/document-lock?envelopeId=${envelopId}&versionOrder=${nextVersionOrder}&versionKey=${versionKey}&draft=true`,
            {}
          );
          console.log("Document locked successfully");
        } catch (lockError) {
          console.error("Document lock error:", lockError);
          throw lockError;
        }

        const filesToUpload = docsList ? docsList.filter((doc: any) => doc?.file != null) : [];
        if (filesToUpload.length > 0) {
          await handleUpload(envelopId);
        }
        if (deletedIds.length > 0) {
          const deleteFormData = new FormData();
          const all_id = docsList.map((item: any) => item.documentId);
          const existingId = all_id.filter((id: any) => !deletedIds.includes(id));
          const all_things = docsList.filter((item: any) => !deletedIds.includes(item?.documentId));
          const existing_file_names = all_things
            .filter((item: any) => existingId.includes(item.documentId))
            .map((item: any) => encodeURIComponent(item?.name || item?.documentName));

          deleteFormData.append("envelopeId", envelopId);
          deleteFormData.append("delete_id", deletedIds.join(","));
          deleteFormData.append(`existing_id`, existingId.join(","));
          deleteFormData.append(`existing_file_names`, existing_file_names.join(","));
          deleteFormData.append("versionOrder", `${1}`);
          deleteFormData.append("versionKey", versionKey);
          deleteFormData.append("draft", JSON.stringify(true));

          try {
            await post("v1/spa/delete/spaDocument", deleteFormData);
            console.log("Files deleted successfully");
          } catch (error) {
            console.error("Delete API error:", error);
            throw error;
          }
        }
        formData.append("envelopeId", envelopId);
        const draftResponse: any = await put("v1/spa/spa-draft-edit", formData);
      } else {
        const createResponse: any = await post("v1/spa/spa-create-document", formData);
        const envelopeId = createResponse.response?.data;

        try {
          const nextVersionOrder = Number(totalVersion ?? 0) + 1;
          await put(
            `v1/workflow/document-lock?envelopeId=${envelopeId}&versionOrder=${nextVersionOrder}&versionKey=${versionKey}`,
            {}
          );
          console.log("New document locked successfully");
        } catch (lockError) {
          console.error("Document lock error:", lockError);
          throw lockError;
        }

        let index = 100;
        const existingDocsList = docsList ? docsList.filter((doc: any) => doc.file === null) : [];

        existingDocsList.forEach((item: any) => {
          const templateDocument = new FormData();
          templateDocument.append(
            "templateDocument",
            JSON.stringify({ documentId: item.documentId, name: item?.name })
          );
          templateDocument.append("envelopeDocumentId", `${index}`);
          templateDocument.append("envelopeId", envelopeId);
          templateDocument.append("templateId", values.templateId);
          templateDocument.append("documentType", "template");
          templateDocument.append("flowType", "external");

          post("v1/clm/templatedoc/toenvelope/upload", templateDocument).catch((error) => {
            console.error("Template document upload error:", error);
          });

          index++;
        });

        await handleUpload(envelopeId);
      }

      openNotification({
        title: "Success",
        message: `${values.projectTitle} saved as draft`,
        type: "success",
      });

      navigate("/spa");
    } catch (error: any) {
      console.error("Error saving draft:", error);
      openNotification({
        title: "Error",
        message: error,
        type: "error",
      });
    } finally {
      setLoaderModal(false);
      setDeletedIds([]);
      setUpdatedFile([]);
      setCreatedFile([]);
    }
  };

  const handleUpload = async (envelopeId: string) => {
    const filesToUpload = docsList ? docsList.filter((doc: any) => doc?.file != null) : [];
    if (filesToUpload.length > 0) {
      setLoaderModal(true);
      setFilesUploadedCount(0);
      setTotalFiles(filesToUpload.length);

      let delay = 0;
      const uploadPromises = filesToUpload.map((fileInfo: any, index: number) => {
        const formDataDocumentUpload = new FormData();
        const docId = fileInfo?.documentId || fileInfo?.id || `${100 + index}`;
        formDataDocumentUpload.append("envelopeId", envelopeId);
        formDataDocumentUpload.append("documentId", docId);
        formDataDocumentUpload.append("create-document-file", fileInfo?.file);
        formDataDocumentUpload.append("draft", JSON.stringify(true));

        return new Promise((resolve, reject) => {
          setTimeout(() => {
            post("v1/spa/upload", formDataDocumentUpload)
              .then(() => {
                setFilesUploadedCount((prevState) => prevState + 1);
                resolve(null);
              })
              .catch((error) => reject(error));
          }, delay);
          delay += 500;
        });
      });

      try {
        await Promise.all(uploadPromises);
      } catch (error) {
        console.error("File upload error:", error);
        setLoaderModal(false);
      }
    }
  };

  const getEnvelopeDetails = () => {
    setIsLoading(true);
    get(`v1/spa/detail?envelopeId=${envelopId}`)
      .then((res: any) => {
        if (res?.response?.data) {
          const awardAndStrategyPaper = res?.response?.data?.awardAndStrategyPaper;
          const budget = res?.response?.data?.budget;
          const fetchedData = res?.response?.data;
          const cost = fetchedData?.currency;
          const selectedNumber = fetchedData?.procurementNumber;
          const authority = fetchedData.approvalAuthority;
          const formattedCost = cost.totalCost
            ? new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(parseFloat(cost.totalCost))
            : cost?.totalCost;
          setDefaultDivisionName(fetchedData.division);
          setTotalVersion(fetchedData?.lastVersion);
          setSelectedPoints(selectedNumber);
          setSelectRole(authority);
          setSelectedOption(authority);
          setDraftApprovalAuthority(authority);
          const existingDocs = fetchedData?.documentVersionResponses || [];
          setDocsList(existingDocs);
          if (existingDocs.length > 0) {
            const maxId = existingDocs.reduce((max: number, doc: any) => {
              const idNum = parseInt(doc.documentId, 10);
              return !isNaN(idNum) && idNum > max ? idNum : max;
            }, 99);
            newDocId = maxId + 1;
          }
          setFormattedCost(formattedCost);
          setPaperValue(awardAndStrategyPaper);
          setBudgetValue(budget);
          setInitialValues((prev) => ({
            ...prev,
            ...fetchedData,
            procurementProcess: selectedNumber,
            additionaldocument:
              fetchedData?.additionaldocument?.map((item: string) => {
                return { url: item };
              }) || null,
            templateId: fetchedData.templateId,
          }));
          setData(res.response.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("log", err);
        openToast({
          content: "Getting SPA Details failed",
          type: "error",
        });
        setIsLoading(false);
      });
  };
  const getReviewers = () => {
    setIsLoading(true);
    get(`v1/workflow/get/reviewers/list?envelopeId=${envelopId}`)
      .then((res: any) => {
        setIsLoading(false);
        if (res.response.data) {
          const reviewers = res.response.data;
          const chosenDesignation = reviewers
            .map((item: any) => item.designation)
            .filter((designations: any) => designation.includes(designations));
          setSignerDetail(reviewers);
          setSelectedDesignation(chosenDesignation);
        }
      })
      .catch((err) => {
        openToast({
          content: "Getting Reviewers Details failed",
          type: "error",
        });
        setIsLoading(false);
      });
  };
  const getWatchers = () => {
    setIsLoading(true);
    get(`v1/workflow/get/watchers/list?envelopeId=${envelopId}`)
      .then((res: any) => {
        setIsLoading(false);
        if (res?.response?.data) {
          setWatchers(res?.response?.data);
        }
      })
      .catch((err) => {
        openToast({
          content: "Getting Wacthers Details failed",
          type: "error",
        });
        setIsLoading(false);
      });
  };
  const getRecords = useCallback(() => {
    get("v1/spa/get-template-list")
      .then((res: any) => {
        if (res.status === "OK") {
          if (res && res.response.data && res.response.data) {
            setTemplateList(res.response.data.records);
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        openToast({
          content: "Getting Templates failed",
          type: "error",
        });
        setIsLoading(false);
      });
  }, []);
  const departmentOptions = [
    { value: "IT", label: "Information Technology" },
    { value: "HR", label: "Human Resources" },
    { value: "Finance", label: "Finance" },
  ];

  const designationOptions = [
    { value: "Manager", label: "Manager" },
    { value: "Engineer", label: "Engineer" },
    { value: "Analyst", label: "Analyst" },
  ];

  const [checkMail, setCheckMail] = useState<any>();
  const [showWarning, setShowWarning] = useState<any>();

  useEffect(() => {
    if (checkMail) {
      get(`v1/user/is-valid-email?userEmail=${checkMail}`)
        .then((res: any) => {
          if (res) {
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, [checkMail]);

  const [approverEmail, setApproverEmail] = useState([]);
  const [approverError, setApproverError] = useState(false);

  const getApproverList = () => {
    setSubmitLoading(true);
    const approverListUrl = `/v1/spa/get-approver-list?authorityGroup=${selectedOption}&subsidiary=${subsidiaryName}&division=${encodeURIComponent(divisionName)}&budget=${encodeURIComponent(
      approverBudget
    )}`;
    get(approverListUrl)
      .then((res: any) => {
        setApproverError(false);
        setIsApproverApiFailed(false);
        if (res && res.response && res.response.data) {
          const responseData = res.response.data;
          if (responseData) {
            setApproverData(responseData);
            const approverEmail = responseData.map((val: any) => ({
              userName: val.userName,
              userEmail: val.userEmail,
              designation: val.designation,
            }));
            setApproverDetails(responseData);
            setApproverEmail(approverEmail);
          } else {
            console.error("No records found in the response");
            setApproverData([]);
            setApproverEmail([]);
          }
        } else {
          console.error("Unexpected response structure:", res);
        }
      })
      .catch((err) => {
        setApproverError(true);
        setIsApproverApiFailed(true);
        setApproverData([]);
        setApproverEmail([]);
        console.error("API Error:", err);
        openToast({
          content: err,
          type: "error",
        });
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };
  const [oneCentreData, setOneCentreData] = useState([]);
  const getUserRecords = () => {
    const subsidiaryUrl = `v1/spa/one-stop-center/get-all-one-stop-center`;
    get(subsidiaryUrl)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          const responseData = res.response.data;
          if (responseData) {
            setOneCentreData(responseData);
          } else {
            console.error("No records found in the response");
            setOneCentreData([]);
          }
        } else {
          console.error("Unexpected response structure:", res);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        openToast({
          content: "Getting One Stop Centre failed",
          type: "error",
        });
      });
  };

  useEffect(() => {
    if (currentStep === 1) {
      getUserRecords();
    }
  }, [currentStep]);

  const [watcherList, setWatcherList] = useState<any>([]);
  const getWatcherList = () => {
    const approverListUrl = `/v1/spa/pcd-watcher/get-watcher-list?order=asc&size=20`;
    get(approverListUrl)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          const responseData = res.response.data.records;
          if (responseData) {
            setWatcherList(responseData);
          } else {
            console.error("No records found in the response");
            setWatcherList([]);
          }
        } else {
          console.error("Unexpected response structure:", res);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        openToast({
          content: "Getting watchers data failed",
          type: "error",
        });
      });
  };

  let previousSelectedOptionWacther = useRef<any>(null);
  let previousSelectedSubsidiaryWacther = useRef<any>(null);
  let previousSelectedDivisionWacther = useRef<any>(null);

  useEffect(() => {
    if (selectedOption && currentStep === 3 && watcherList.length <= 0) {
      getWatcherList();
    } else if (
      selectedOption &&
      currentStep === 3 &&
      watcherList.length > 0 &&
      previousSelectedOptionWacther.current !== selectedOption
    ) {
      getWatcherList();
    } else if (previousSelectedSubsidiaryWacther.current !== subsidiaryName && currentStep === 3 && selectedOption) {
      getWatcherList();
    } else if (selectedOption && currentStep === 3 && previousSelectedDivisionWacther.current !== divisionName) {
      getWatcherList();
    }
    previousSelectedOptionWacther.current = selectedOption;
    previousSelectedSubsidiaryWacther.current = subsidiaryName;
    previousSelectedDivisionWacther.current = divisionName;
  }, [currentStep === 3]);

  let previousSelectedOption = useRef<any>(null);
  let previousSelectedSubsidiary = useRef<any>(null);
  let previousSelectedDivision = useRef<any>(null);

  useEffect(() => {
    if (selectedOption && currentStep === 2 && !approverData) {
      getApproverList();
    } else if (envelopId && budgetValue && selectedOption && currentStep === 2) {
      getApproverList();
    } else if (
      selectedOption &&
      currentStep === 2 &&
      approverData &&
      previousSelectedOption.current !== selectedOption
    ) {
      getApproverList();
    } else if (previousSelectedSubsidiary.current !== subsidiaryName && selectedOption) {
      getApproverList();
    } else if (selectedOption && previousSelectedDivision.current !== divisionName) {
      getApproverList();
    }
    previousSelectedOption.current = selectedOption;
    previousSelectedSubsidiary.current = subsidiaryName;
    previousSelectedDivision.current = divisionName;
  }, [currentStep === 2, selectedOption, budgetValue]);

  const getSubsidiaryRecords = (subsidiaryId: any, spaSubsidiaryId: any) => {
    const subsidiaryUrl = `v1/subsidiary/all-subsidiary`;
    get(subsidiaryUrl)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          const responseData = res.response.data;
          if (responseData) {
            setSubsidiaryData(responseData);
          } else {
            console.error("No records found in the response");
            setSubsidiaryData([]);
          }
        } else {
          console.error("Unexpected response structure:", res);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        openToast({
          content: "Getting Subsidiary failed",
          type: "error",
        });
      });

    if (subsidiaryId) {
      const divisionUrl = `/v1/division/get-all-divisionBySubsidiary?subsidiary=${subsidiaryId}`;
      get(divisionUrl)
        .then((res: any) => {
          if (res && res.response && res.response.data) {
            const responseData = res.response.data;
            if (responseData) {
              setDivisionData(responseData);
            } else {
              console.error("No records found in the response");
              setSubsidiaryData([]);
            }
          } else {
            console.error("Unexpected response structure:", res);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          openToast({
            content: "Getting Subsidiary failed",
            type: "error",
          });
        });
    }
    if (spaSubsidiaryId) {
      const divisionUrl = `/v1/division/get-all-divisionBySubsidiary?subsidiary=${spaSubsidiaryId}`;
      get(divisionUrl)
        .then((res: any) => {
          if (res && res.response && res.response.data) {
            const responseData = res.response.data;
            if (responseData) {
              setSpaDivisionData(responseData);
            } else {
              console.error("No records found in the response");
              setSubsidiaryData([]);
            }
          } else {
            console.error("Unexpected response structure:", res);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          openToast({
            content: "Getting Subsidiary failed",
            type: "error",
          });
        });
    }
  };

  useEffect(() => {
    getSubsidiaryRecords("", spaSubsidiaryId);
  }, [spaSubsidiaryId]);
  useEffect(() => {
    getSubsidiaryRecords(subsidiaryId, "");
  }, [subsidiaryId]);

  const [openPdf, setOpenPdf] = useState<any>(false);
  const onPreviewDoument = async (envelope: any, separate?: boolean) => {
    if (!envelope || loadingDocId) return;

    setSelectDocument(envelope);
    setLoadingDocId(envelope.documentId);
    setOpenPdf(separate);

    try {
      let fileURL: string;

      if (envelope?.isNew && envelope?.documentBase64) {
        const byteCharacters = atob(envelope.documentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        fileURL = URL.createObjectURL(blob);
      } else {
        const response = await fetch(envelope.blobUrl + docVersionKey, { method: "GET" });
        const blobData = await response.blob();
        fileURL = URL.createObjectURL(blobData);
      }

      if (separate) {
        const filename = `${envelope.documentName || envelope.name}.pdf`;
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        downloadLink.download = filename;
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(fileURL);
      } else {
        setSelectedDocument(fileURL);
      }
    } catch (error) {
      console.error("Error handling document:", error);
    }

    setLoadingDocId("");
  };

  const viewDocument = async (envelope: any, isDownload = false) => {
    if (loadingDocId) return;
    setLoadingDocId(envelope.documentId);
    try {
      let fileURL: string;

      if (envelope?.isNew && envelope?.documentBase64) {
        const byteCharacters = atob(envelope.documentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        fileURL = URL.createObjectURL(blob);
      } else {
        const response = await fetch(envelope.blobUrl + docVersionKey, { method: "GET" });
        const blobData = await response.blob();
        fileURL = URL.createObjectURL(blobData);
      }

      if (isDownload) {
        const filename = `${envelope.documentName || envelope.name}.pdf`;
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        downloadLink.download = filename;
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(fileURL);
      } else {
        setSelectedDocumentReview(fileURL);
      }
    } catch (error) {
      console.error("Error handling document:", error);
    }
    setLoadingDocId("");
  };
  useEffect(() => {
    getRecords();
    setIsLoading(true);
  }, [getRecords]);

  const zoomIn = () => {
    setScale(scale + 0.1);
  };

  const zoomOut = () => {
    if (scale > 0.1) {
      setScale(scale - 0.1);
    }
  };

  const handleOptionChange = (event: any) => {
    setSelectRole(event?.target?.value);
    setSelectedOption(event?.target?.value);
  };

  const generateAndUploadOverallPdf = async (envelopeId: string, versionKey: string, nextVersionOrder: number) => {
    try {
      const url1 = `v1/spa/detail?envelopeId=${envelopeId}`;
      const url2 = `v1/workflow/get/reviewers/list?envelopeId=${envelopeId}`;
      const url3 = `v1/workflow/get/watchers/list?envelopeId=${envelopeId}`;

      const [dataRes, reviewersRes, watchersRes]: any[] = await Promise.all([get(url1), get(url2), get(url3)]);

      const freshData = dataRes?.response?.data;
      const freshReviewers = reviewersRes?.response?.data;
      const freshWatchers = watchersRes?.response?.data;

      const pdfData = await getPdfData({
        overAllData: freshData,
        overAllReviewers: freshReviewers,
        overAllWatchers: freshWatchers,
      });

      const docDefinition = printPdf(
        {
          ...pdfData.data,
          reviewers: pdfData.reviewers,
          watchers: pdfData.watchers,
          documents: pdfData.documents,
          logs: pdfData.logs,
          docVersion: pdfData.docVersion,
          comments: pdfData.comments,
        },
        "view"
      );

      const pdfBlob = await getPdfBlobFromDocDefinition(docDefinition);
      const pdfFile = createPdfFile(pdfBlob, `SPA${freshData?.projectId}(V${nextVersionOrder}).pdf`);

      const documentDataFields =
        freshData?.documentVersionResponses?.map((item: any) => ({
          id: item.documentId,
          name: item?.documentName,
        })) || [];

      const maxDocId = documentDataFields.reduce((max: number, doc: any) => {
        const numericId = parseInt(doc.id, 10);
        return isNaN(numericId) ? max : Math.max(max, numericId);
      }, 0);
      const randomCreateId = maxDocId + 1;

      const overallPdfRegex = freshData?.projectId
        ? new RegExp(`^SPA${freshData?.projectId}\\(V\\d+\\)\\.pdf$`, "i")
        : /^SPA.*\(V\d+\)\.pdf$/i;
      const existingOverallDoc = documentDataFields.find(
        (doc: any) => overallPdfRegex.test(doc.name) || /^SPA.*\(V\d+\)\.pdf$/i.test(doc.name)
      );
      const deleteIds = existingOverallDoc ? [existingOverallDoc.id] : [];
      const remainingDocs = documentDataFields.filter((doc: any) => !deleteIds.includes(doc.id));

      const deleteFormData = new FormData();
      deleteFormData.append("existing_id", remainingDocs.map((d: any) => d.id).join(","));
      deleteFormData.append(
        "existing_file_names",
        remainingDocs.map((d: any) => encodeURIComponent(d.name))
      );
      deleteFormData.append("versionOrder", `${nextVersionOrder}`);
      deleteFormData.append("versionKey", versionKey);
      deleteFormData.append("envelopeId", envelopeId);
      deleteFormData.append("delete_id", deleteIds.join(","));

      const uploadFormData = new FormData();
      uploadFormData.append("create_id", `${randomCreateId}`);
      uploadFormData.append("versionOrder", `${nextVersionOrder}`);
      uploadFormData.append("versionKey", versionKey);
      uploadFormData.append("envelopeId", envelopeId);
      uploadFormData.append("create-document-file", pdfFile);

      await put(
        `v1/workflow/document-lock?envelopeId=${envelopeId}&versionOrder=${nextVersionOrder}&versionKey=${versionKey}`,
        {}
      );
      await post(`v1/spa/delete/spaDocument`, deleteFormData);
      await put(`v1/spa/update/spaDocument`, uploadFormData);
    } catch (err) {
      console.error("[generateAndUploadOverallPdf] Failed to generate or upload overall PDF:", err);
      throw err;
    }
  };

  const onSubmit = async (values: any) => {
    let finalReviewers: any[] = [];
    let routingOrderCounter = 1;

    const docResponse = values?.documentVersionResponses;
    let watchers = values.watchers.map((watcher: any) => {
      const { department, name, email, ...rest } = watcher;
      return rest;
    });

    let signers = values.signers.map((signer: any, index: number) => {
      const { department, ...rest } = signer;
      return { ...rest, subsidiary: subsidiaryName, routingOrder: "1" };
    });

    if (signers.length > 0) routingOrderCounter = 2;

    let oneCenter = oneCenterEnable
      ? values.oneCenter.map((signer: any, index: number) => {
        const { ...rest } = signer;
        return { ...rest, routingOrder: routingOrderCounter };
      })
      : [];

    if (oneCenter.length > 0) routingOrderCounter++;

    const allReviewers = values?.reviewers?.filter((rev: any) => rev?.designation && rev?.email);
    const reviewersByDesignation: Record<string, any[]> = {};

    allReviewers.forEach((rev: any) => {
      const isSigner = signers.some((s: any) => s.email === rev.email && s.designation === rev.designation);
      if (isSigner) return;

      if (!reviewersByDesignation[rev.designation]) {
        reviewersByDesignation[rev.designation] = [];
      }
      const alreadyExists = reviewersByDesignation[rev.designation].some((r: any) => r.email === rev.email);
      if (!alreadyExists) reviewersByDesignation[rev.designation].push(rev);
    });

    if (reviewersByDesignation["R1"]) {
      finalReviewers.push(
        ...reviewersByDesignation["R1"].map((rev: any) => ({
          ...rev,
          routingOrder: routingOrderCounter,
        }))
      );
      routingOrderCounter++;
      delete reviewersByDesignation["R1"];
    }

    const airportManagerOrderMap: any = {
      "APC SECRETARIAT": 2,
      "APC MEMBER": 3,
      "AIRPORT MANAGER": 4,
    };

    if (selectRole === "airportManager") {
      Object.keys(airportManagerOrderMap).forEach((designation) => {
        if (reviewersByDesignation[designation]) {
          finalReviewers.push(
            ...reviewersByDesignation[designation].map((rev: any) => ({
              ...rev,
              routingOrder: airportManagerOrderMap[designation],
            }))
          );
          delete reviewersByDesignation[designation];
        }
      });
    }

    Object.keys(reviewersByDesignation).forEach((designation) => {
      finalReviewers.push(
        ...reviewersByDesignation[designation].map((rev: any) => ({
          ...rev,
          routingOrder: routingOrderCounter,
        }))
      );
      routingOrderCounter++;
    });

    const combinedReviewers = [...finalReviewers, ...signers, ...oneCenter];
    const allowedReviewerKeys = ["name", "email", "designation", "division", "subsidiary", "routingOrder"];

    const cleanedReviewers = combinedReviewers.map((reviewer: any) => {
      return Object.fromEntries(Object.entries(reviewer).filter(([key]) => allowedReviewerKeys.includes(key)));
    });

    let totalCost = (values.totalCost || costValue || "").replace(/,/g, "");
    const payload: any = {
      budget: values?.budgetDrop || values?.budget,
      awardAndStrategyPaper: values?.paperDrop || values?.awardAndStrategyPaper,
      templateId: values.templateId,
      templateName: values.templateName,
      projectTitle: values.projectTitle,
      procurementNumber: selectedPoints,
      projectSummary: values.projectSummary,
      subsidiary: subsidiaryName,
      division: values.division,
      procurementSummary: values.procurementSummary,
      recommendedVendor: values.recommendedVendor,
      contractValue: values.contractValue,
      contractPeriod: values.contractPeriod,
      approvalAuthority: selectRole,
      reminders: {
        reminderFrequency: values.reminderFrequency,
        reminderDelay: values.reminderDelay,
        reminderEnabled: values.reminderEnabled,
      },
      expirations: {
        expiryWarn: values.expiryWarn,
        expiryAfter: values.expiryAfter,
        expiryEnabled: true,
      },
      currency: {
        currencyCode: values.currencyCode || defaultCurrencyCode,
        totalCost: totalCost,
        tax: values.tax,
      },
      reviewers: [...cleanedReviewers],
      watchers: [...watchers],
      status: "created",
      documentLinkDetails: values?.documentLinkDetails,
    };

    const formData = new FormData();
    const formDataFile = new FormData();
    const templateFile = new FormData();

    let allDocsList = [...docsList];
    let createDocsList = allDocsList.filter((doc: any) => doc.file !== null);
    let existingDocsList = allDocsList.filter((doc: any) => doc.file === null);

    if (existingDocsList && existingDocsList.length > 0) {
      existingDocsList.map((item: any) => templateFile.append("create_id", item.documentId));
    }

    createDocsList.map((fileInfo: any) => {
      formDataFile.append("create-document-file", fileInfo.file);
    });

    formData.append("body", JSON.stringify(payload));
    setSubmitLoading(true);

    const generateRandomUADId = () => Math.floor(Math.random() * 1000000000).toString();
    const versionKey = generateRandomUADId();

    if (envelopId) {
      formData.append("envelopeId", envelopId);
      try {
        const draftResponse: any = await put("v1/spa/spa-draft-edit", formData);
        const envelopeId = draftResponse.response?.data || envelopId;

        let apiCallsSuccessful = true;

        const filesToUpload = docsList ? docsList.filter((doc: any) => doc?.file != null) : [];
        if (filesToUpload.length > 0) {
          try {
            await handleUpload(envelopeId);
          } catch (error) {
            apiCallsSuccessful = false;
            throw error;
          }
        }

        if (deletedIds.length > 0) {
          try {
            const all_id = docsList.map((item: any) => item.documentId);
            const existingId = all_id.filter((id: any) => !deletedIds.includes(id));
            const all_things = docsList.filter((item: any) => !deletedIds.includes(item?.documentId));
            const existing_file_names = all_things
              .filter((item: any) => existingId.includes(item.documentId))
              .map((item: any) => encodeURIComponent(item?.name || item?.documentName));

            const deleteFormData = new FormData();
            deleteFormData.append("envelopeId", envelopeId);
            deleteFormData.append("delete_id", deletedIds.join(","));
            deleteFormData.append(`existing_id`, existingId.join(","));
            deleteFormData.append(`existing_file_names`, existing_file_names.join(","));
            deleteFormData.append("versionOrder", `${totalVersion + 1}`);
            deleteFormData.append("versionKey", versionKey);
            deleteFormData.append("draft", JSON.stringify(true));

            await post("v1/spa/delete/spaDocument", deleteFormData);
          } catch (error) {
            apiCallsSuccessful = false;
            console.error("Delete API error:", error);
            throw error;
          }
        }

        if (apiCallsSuccessful) {
          await put(`v1/spa/draft-transfer?envelopeId=${envelopeId}`, {});
          await put(`v1/spa/trigger/reviewer-mail?envelopeId=${envelopeId}&templateId=${values.templateId}`, {});

          const targetEnvId = envelopeId || envelopId;
          const nextVersionOrder = Number(totalVersion ?? 0) + 1;
          try {
            await generateAndUploadOverallPdf(targetEnvId, versionKey, nextVersionOrder);
          } catch (pdfErr) {
            console.error("PDF generation failed:", pdfErr);
            openNotification({
              title: "PDF Warning",
              message: "Overall SPA PDF generation encountered an issue, but document submission completed.",
              type: "warning",
            });
          }

          openNotification({
            title: "Success",
            message: `${values.projectTitle} is onboarded successfully`,
            type: "success",
          });
          navigate("/spa");
        }
      } catch (error) {
        console.error("Error submitting:", error);
        openNotification({
          title: "Error",
          message: "Failed to submit",
          type: "error",
        });
      } finally {
        setSubmitLoading(false);
      }
    } else {
      formData.append("templateId", values.templateId);
      formData.append("fileCount", `${allDocsList.length}`);
      setTotalFiles(createDocsList.length);
      setFilesUploadedCount(0);

      try {
        post("v1/spa/spa-create-document", formData)
          .then((res: any) => {
            const envelopeId = res.response.data;
            setNewEnvelopeId(envelopeId);
            let ind = 100;
            let templateRandom = 200;

            existingDocsList.forEach((value, key) => {
              const templateDocument = new FormData();
              const templateDetail = {
                documentId: value.documentId,
                name: value?.name,
              };
              templateDocument.append("templateDocument", JSON.stringify(templateDetail));
              templateDocument.append("envelopeDocumentId", `${templateRandom}`);
              templateDocument.append("envelopeId", envelopeId);
              templateDocument.append("templateId", values.templateId);
              templateDocument.append("documentType", "template");
              templateDocument.append("flowType", "external");
              post(`v1/clm/templatedoc/toenvelope/upload?`, templateDocument).catch((err: any) => {
                console.log(err);
              });
              templateRandom += 1;
            });

            let delay = 0;

            function createPromise(formDataDocumentUpload: any, delay: number) {
              return new Promise((resolve, reject) => {
                setTimeout(() => {
                  post("v1/spa/upload", formDataDocumentUpload)
                    .then((fileRes: any) => {
                      setFilesUploadedCount((prevState) => prevState + 1);
                      resolve(fileRes);
                    })
                    .catch((err) => {
                      console.log(err);
                      reject(err);
                    });
                }, delay);
              });
            }

            try {
              let promises: any = [];
              createDocsList.forEach((fileInfo: any, key: any) => {
                const formDataDocumentUpload = new FormData();
                const docId = fileInfo?.documentId || fileInfo?.id || ind.toString();
                formDataDocumentUpload.append("envelopeId", envelopeId);
                formDataDocumentUpload.append("documentId", docId);
                formDataDocumentUpload.append("create-document-file", fileInfo.file);
                promises.push(createPromise(formDataDocumentUpload, delay));
                delay += 500;
                ind += 1;
              });

              setLoaderModal(true);

              Promise.all(promises)
                .then(async (results) => {
                  if (results) {
                    await put(
                      `v1/spa/trigger/reviewer-mail?envelopeId=${envelopeId}&templateId=${values.templateId}`,
                      {}
                    );
                  }

                  const nextVersionOrder = Number(data?.lastVersion ?? 0) + 1;
                  try {
                    await generateAndUploadOverallPdf(envelopeId, versionKey, nextVersionOrder);
                  } catch (pdfErr) {
                    console.error("PDF generation failed (non-blocking):", pdfErr);
                  }
                })
                .catch((error) => {
                  console.error("One or more promises were rejected:", error);
                  setLoaderModal(false);
                });
            } catch (e) {
              console.log("file upload error", e);
            }

            setSubmitLoading(false);
          })
          .catch((err) => {
            setSubmitLoading(false);
          });
      } catch (e) {
        setFilesUploadedCount(0);
        setSubmitLoading(false);
      }
    }
  };

  const validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleRadioChange = (value: any) => {
    setSelectedPoints(value);
  };

  const handleRemove = (file: any) => {
    setIsUploadTouched(false);
    if (!file.isNew) {
      setDeletedIds([...deletedIds, file.documentId]);
    }
    if (file?.documentId) {
      setUpdatedFile(updatedFile?.filter((item: any) => item.documentId != file.documentId));
      setCreatedFile(createdFile?.filter((item: any) => item.documentId != file.documentId));
      setDocuments(documents?.filter((item: any) => item.documentId != file.documentId));
    }
    const index = docsList.findIndex((doc: any) => doc.documentId === file.documentId);
    const newFileList = [...docsList];
    newFileList.splice(index, 1);
    setDocsList(newFileList);
    if (file.name === selectDocument?.name || null) {
      setSelectDocument(null);
    } else {
      setSelectDocument(selectDocument);
    }
  };

  let oneCenterEnable =
    selectRole === "airportManager"
      ? false
      : ["1a", "1b", "1c", "1d", "1e", "1f", "1g", "1h", "1i", "4"].includes(selectedPoints?.toString());
  const uploadProps: UploadProps = {
    onRemove: (file) => handleRemove(file),
    onChange: (info: any) => {
      setIsUploadTouched(true);
      const file = info.file;
      if (file.type !== "application/pdf") {
        message.error("Incorrect format, only PDF files are allowed");
        return;
      }
      if (info.file.size <= 40 * 1024 * 1024) {
        newDocId++;
        handleFileChange(info);
      } else {
        message.error("Adding the file exceeds the 40 MB limit");
      }
    },
    beforeUpload: (file) => {
      return false;
    },
  };

  const stepItems: any = [
    {
      key: 0,
      item: "Project Information",
      title: "Project Information",
      icon: <Icon icon={currentStep > 0 ? "charm:tick" : "mdi:form"} />,
    },
    {
      key: 1,
      item: "Project Documents",
      title: "Project Documents",
      icon: <Icon icon={currentStep > 0 ? "charm:tick" : "mdi:file-document-outline"} />,
    },
    {
      key: 2,
      item: "Approvers",
      title: "Approvers",
      icon: <Icon icon={currentStep > 2 ? "charm:tick" : "akar-icons:eye-open"} />,
    },
    {
      key: 3,
      item: "Watchers",
      title: "Watchers",
      icon: <Icon icon={currentStep > 3 ? "charm:tick" : "akar-icons:eye-open"} />,
    },
    {
      key: 4,
      item: "Review & Submit",
      title: "Review & Submit",
      icon: <Icon icon={currentStep > 4 ? "charm:tick" : "mdi:application-edit-outline"} />,
    },
  ];

  const validationSchema1 = yup.object().shape({
    budgetDrop: yup.string().required("Budget is required"),
    paperDrop: yup.string().required("SPA Type is required"),
    templateId: yup.string().required("Template name is required"),
    projectTitle: yup
      .string()
      .trim("Remove leading and trailing spaces")
      .strict(true)
      .required("Project Name is required"),
    procurementSummary: yup.string().strict(true).required("Procurement Summary is required"),
    projectSummary: yup.string().strict(true).required("Project Summary is required"),
    recommendedVendor: yup.string().strict(true).required("Recommended Vendor is required"),
    division: yup.string().strict(true).required("Cost Centre is required"),
    subsidiary: yup.string().strict(true).required("Subsidiary/Division is required"),
    contractPeriod: yup
      .string()
      .trim("Contract Period cannot include leading and trailing spaces")
      .strict(true)
      .required("Contract Period is required"),
    contractValue: yup.string().required("Contract value is required"),
    totalCost: yup
      .string()
      .strict(true)
      .required("Budget Amount is required")
      .test("totalCost", "Budget Amount value must be between RM 1.00 to RM 10,000,000", function (value) {
        if (value) {
          value = value.toString();
          let newVal: any = value.replace(/,/g, "");
          newVal = Number(newVal);
          if (newVal >= 1 && newVal <= 10000000) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }),
  });

  const validationSchema4 = yup.object().shape({
    documentLinkDetails: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().trim().required("Document name is required"),

          url: yup
            .string()
            .trim()
            .required("Document link is required")
            .matches(/^https:\/\//, "File URL must start with https://"),
        })
      )
      .min(1, "At least one document is required"),
  });

  useEffect(() => {
    if (!isDraftSaved) {
      if (filesUploadedCount > 0) {
        if (filesUploadedCount == totalFiles) {
          openNotification({
            title: "Success",
            message: `${projectName} is onboarded successfully`,
            type: "success",
          });
        }
      }
    }
  }, [filesUploadedCount == totalFiles]);

  const validationSchema2 = yup.object().shape({
    reviewerName: yup
      .string()
      .trim("Name cannot include leading and trailing spaces")
      .strict(true)
      .test("name-and-email", "Name is required when Email is provided", function (value) {
        const reviewerEmail = this.parent.reviewerEmail;
        if (reviewerEmail && !value) {
          return false;
        }
        return true;
      })
      .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
    reviewerEmail: yup
      .string()
      .lowercase("Email address must be a lowercase")
      .matches(
        new RegExp(`^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.join("|")})$`),
        `Permitted Domains: ${allowedDomainsAll.join(", ")}`
      )
      .strict(true)
      .email("Email address must be a valid email")
      .test("name-and-email", "Email is required when Name is provided", function (value) {
        const reviewerName = this.parent.reviewerName;
        if (reviewerName && !value) {
          return false;
        }
        return true;
      })
      .test("duplicate-email", "Duplicate email found in signers or watchers", function (value) {
        if (value) {
          const signersEmails = this.parent.signers.map((signer: any) => signer.email);
          const watchersEmails = this.parent.watchers.map((watcher: any) => watcher.email);

          const duplicateEmails = [...signersEmails, ...watchersEmails].filter((email) => email === value);

          return duplicateEmails.length === 0;
        } else {
          return true;
        }
      }),
    signers: yup.array().of(
      yup.object().shape({
        name: yup
          .string()
          .trim("Name cannot include leading and trailing spaces")
          .strict(true)
          .required("Name required")
          .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
        email: yup
          .string()
          .matches(
            new RegExp(`^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.join("|")})$`),
            `Permitted Domains: ${allowedDomainsAll.join(", ")}`
          )
          .lowercase("Email address must be a lowercase")
          .email("Email address must be a valid email")
          .strict(true)
          .required("Email required"),
        designation: yup.string().strict(true).required("Designation is required"),
        division: yup.string().strict(true).required("Cost Centre is required"),
        subsidiary: yup.string().strict(true).required("Subsidiary/Division is required"),
      })
    ),
    reviewers: yup.array().of(
      yup.object().shape({
        designation: yup.string().strict(true).required("Designation is required"),
        name: yup
          .string()
          .trim("Name cannot include leading and trailing spaces")
          .strict(true)
          .required("Name required")
          .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
        email: yup
          .string()
          .matches(
            new RegExp(`^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.join("|")})$`),
            `Permitted Domains: ${allowedDomainsAll.join(", ")}`
          )
          .lowercase("Email address must be a lowercase")
          .email("Email address must be a valid email")
          .strict(true)
          .required("Email required"),
      })
    ),
    oneCenter: yup.array().when("oneCenterEnable", {
      is: true,
      then: yup.array().of(
        yup.object().shape({
          name: yup
            .string()
            .trim("Name cannot include leading and trailing spaces")
            .strict(true)
            .required("Name required"),
          email: yup
            .string()
            .matches(
              new RegExp(`^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.join("|")})$`),
              `Permitted Domains: ${allowedDomainsAll.join(", ")}`
            )
            .lowercase("Email address must be a lowercase")
            .email("Email address must be a valid email")
            .strict(true)
            .required("Email required"),
        })
      ),
      otherwise: yup.array(),
    }),
  });

  const numberOfApproverSets = 4;

  const [inputSets, setInputSets] = useState(
    Array.from({ length: numberOfApproverSets }, (_, i) => ({
      designation: "",
      name: "",
      email: "",
    }))
  );

  const validationSchema3 = yup.object().shape({
    watchers: yup.array().of(
      yup.lazy((value, options: any) => {
        const index = options.index;
        const technicalIndex = watcherList.length + 1;
        if (index >= 1 && index <= watcherList.length) {
          return yup.mixed().notRequired();
        }
        if (index > technicalIndex) {
          return yup.object().shape({
            userName: yup
              .string()
              .trim("Name cannot include leading and trailing spaces")
              .strict(true)
              .optional()
              .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
            userEmail: yup
              .string()
              .optional()
              .matches(
                new RegExp(`^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.join("|")})$`),
                `Permitted Domains: ${allowedDomainsAll.join(", ")}`
              )
              .lowercase("Email address must be a lowercase")
              .email("Email address must be a valid email")
              .strict(true),
          });
        }
        return yup.object().shape({
          userName: yup
            .string()
            .trim("Name cannot include leading and trailing spaces")
            .strict(true)
            .required("Name required")
            .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
          userEmail: yup
            .string()
            .matches(
              new RegExp(`^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.join("|")})$`),
              `Permitted Domains: ${allowedDomainsAll.join(", ")}`
            )
            .lowercase("Email address must be a lowercase")
            .email("Email address must be a valid email")
            .strict(true)
            .required("Email required"),
        });
      }) as unknown as yup.AnySchema<any>
    ),
  });

  const [projectName, setProjectName] = useState<any>();

  return (
    <>
      <ContentWrapper
        loading={isloading}
        customTitle={
          <Space align="start">
            <Icon
              onClick={() => navigate(-1)}
              icon="akar-icons:arrow-left"
              style={{
                fontSize: "1.8rem",
                cursor: "pointer",
                color: styles.primary,
                marginRight: styles.whitespace1,
              }}
            />
            <span>
              <Typography.Title
                level={3}
                style={{ margin: 0 }}
              >
                Add SPA
              </Typography.Title>
            </span>
          </Space>
        }
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          onSubmit={(values, formikHelper) => {
            onSubmit(values);
          }}
          validationSchema={
            (currentStep === 0 && validationSchema1) ||
            (currentStep === 1 && validationSchema4) ||
            (currentStep === 2 && validationSchema2) ||
            (currentStep === 3 && validationSchema3)
          }
        >
          {(props) => {
            const { values, setFieldValue } = props;
            setapproverBudget(values.budgetDrop || props.values.budget);
            useEffect(() => {
              if (envelopId) {
                setFieldValue("budgetDrop", budgetValue || props.values.budget);
                setFieldValue("paperDrop", paperValue || props.values.awardAndStrategyPaper);
              }
            }, [
              envelopId,
              budgetValue,
              paperValue,
              props.values.budget,
              props.values.awardAndStrategyPaper,
              currentStep === 0,
              currentStep === 1,
              currentStep === 2,
              currentStep === 3,
            ]);
            useEffect(() => {
              setFieldValue(`expiryWarn`, props.values.expiryWarn);
              setFieldValue(`expiryAfter`, props.values.expiryAfter);
              setFieldValue(`totalCost`, "0");
            }, []);
            useEffect(() => {
              props.values.signers.forEach((_, index) => {
                setFieldValue(`signers[${index}].name`, "");
                setFieldValue(`signers[${index}].email`, "");
                setFieldValue(`signers[${index}].designation`, "");
                setFieldValue(`signers[${index}].division`, "");
                setFieldValue(`signers[${index}].subsidiary`, "");
              });
            }, [selectRole]);

            useEffect(() => {
              const subsidiaryUrl = `v1/subsidiary/all-subsidiary`;
              get(subsidiaryUrl)
                .then((res: any) => {
                  const subsidiaries = res?.response?.data || [];
                  setSubsidiaryDraft(subsidiaries);
                  const matchedSubsidiaries = subsidiaries.find((item: any) => item?.name == values?.subsidiary);
                  if (matchedSubsidiaries) {
                    const exactSubsidiaryID = matchedSubsidiaries && matchedSubsidiaries?.subsidiaryId;
                    const divisionUrl = `/v1/division/get-all-divisionBySubsidiary?subsidiary=${exactSubsidiaryID}`;
                    get(divisionUrl)
                      .then((res: any) => {
                        const divisions = res?.response?.data || [];
                        const divisionList = divisions.map((item: any) => ({
                          division: item?.division,
                          uniqueId: item?.uniqueId || item?.division,
                        }));
                        setDivisionData(divisionList);
                      })
                      .catch((err: any) => {
                        console.log(err);
                      });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }, [values?.subsidiary]);
            useEffect(() => {
              let cost = values.totalCost;
              if (typeof cost === "number" && cost > 10000000) {
                setShowWarning(true);
              } else if (typeof cost === "string") {
                if (cost.includes(",")) {
                  cost = cost.replace(/,/g, "");
                }
                if (Number(cost) > 10000000) {
                  setShowWarning(true);
                } else {
                  setShowWarning(false);
                }
              }
            }, [values.totalCost]);

            useEffect(() => {
              const email = props?.values?.signers[0]?.email;
              if (email && props.errors) {
                const domain = email.split("@")[1];

                if (allowedDomainsAll.includes(domain)) {
                  setCheckMail(email);
                }
              }
            }, [props?.values?.signers[0]?.email, props.errors]);
            const getReviewerCount = (role: any) => {
              switch (role) {
                case "MD/GCEO":
                  return 5;
                case "GCFO/GCOO":
                  return 4;
                case "HeadofSubsidiary":
                  return 2;
                case "airportManager":
                  return 3;
                default:
                  return 0;
              }
            };
            const getDesignations = (count: any) => {
              switch (count) {
                case 5:
                  return ["R2", "R3", "GCEO", "MD"];
                case 4:
                  return ["R2", "GCFO", "GCOO", "COO"];
                case 2:
                  return ["R2", "Head of Subsidiary"];
                case 3:
                  return ["R1", "R2", "AIRPORT MANAGER"];
                default:
                  return [];
              }
            };

            const reviewerCount = getReviewerCount(selectRole);
            const designations = getDesignations(reviewerCount);
            let approverDesignation: any;

            if (designations) {
              const filterData = approverEmail.map((des: any) => des.designation);
              approverDesignation = designations.filter((val) => filterData.includes(val));
            }

            useEffect(() => {
              if (envelopId) {
                setFieldValue("oneCenterEnable", false);
              } else if (!oneCenterEnable) {
                setFieldValue("oneCenterEnable", false);
              } else if (oneCenterEnable) {
                setFieldValue("oneCenterEnable", true);
              }
            }, [oneCenterEnable, envelopId]);
            const isEditorEmpty = (html: string) => html.replace(/<(.|\n)*?>/g, "").trim().length === 0;
            useEffect(() => {
              if (currentStep === 1 && approverData?.length > 0 && props?.values?.signers) {
                approverData.forEach((value: any, index: any) => {
                  props.setFieldTouched(`reviewers[${index}].designation`, false);
                  props.setFieldTouched(`reviewers[${index}].userName`, false);
                  props.setFieldTouched(`reviewers[${index}].userEmail`, false);
                });
              } else if (currentStep === 1 && !props.values.reviewers[0]?.name) {
                props.setFieldTouched(`reviewers.designation`, false);
                props.setFieldTouched(`reviewers.userName`, false);
                props.setFieldTouched(`reviewers.userEmail`, false);
              } else if (currentStep === 2 && props?.values?.reviewers[0]?.name) {
                approverData.forEach((value: any, index: any) => {
                  props.setFieldTouched(`reviewers[${index}].designation`, false);
                  props.setFieldTouched(`reviewers[${index}].userName`, false);
                  props.setFieldTouched(`reviewers[${index}].userEmail`, false);
                });
              }
            }, [currentStep === 1, , props.values.reviewers]);

            let approvers: any[];

            useEffect(() => {
              if (approverData && approverData.length > 0) {
                setFieldValue("reviewers", []);

                const processedDesignations = new Set();
                const designationOrder = designations;

                let orderedApproverData = approverData.sort((a: any, b: any) => {
                  return designationOrder.indexOf(a.designation) - designationOrder.indexOf(b.designation);
                });
                const order: Record<string, number> = {
                  R1: 1,
                  R2: 2,
                };

                approverData.sort((a: any, b: any) => {
                  const aOrder = order[a.designation] ?? 3;
                  const bOrder = order[b.designation] ?? 3;

                  return aOrder - bOrder;
                });
                if (selectRole === "GCFO/GCOO") {
                  orderedApproverData = approverData.filter(
                    (des: any) =>
                      des.designation === "R1" ||
                      des.designation === "GCFO" ||
                      des.designation === "R2" ||
                      des.designation === "GCOO" ||
                      des.designation === "COO" ||
                      des.designation === "CAO" ||
                      des.designation === "CFO"
                  );
                }

                let processed = false;

                approverDesignation.forEach((designation: any) => {
                  let validIndex = 0;

                  orderedApproverData.forEach((approver: any) => {
                    if (!approver.designation || !approver.userName || !approver.userEmail) {
                      return;
                    }

                    if (processedDesignations.has(approver.designation)) {
                      return;
                    }

                    const allowedDesignations = ["GCEO", "MD", "GCFO", "GCOO", "COO", "CAO", "CFO"];

                    if (!processed && allowedDesignations.includes(approver.designation)) {
                      processed = true;
                      setFieldValue(`reviewers[${validIndex}].designation`, approver.designation);
                      setFieldValue(`reviewers[${validIndex}].name`, approver.userName);
                      setFieldValue(`reviewers[${validIndex}].email`, approver.userEmail);

                      let routingOrder;
                      switch (approver.designation) {
                        case "R1":
                          routingOrder = oneCenterEnable ? "3" : "2";
                          break;
                        case "R2":
                          routingOrder =
                            selectedOption === "airportManager"
                              ? oneCenterEnable
                                ? "4"
                                : "3"
                              : oneCenterEnable
                                ? "3"
                                : "2";
                          break;
                        case "Airport Manager":
                          routingOrder = oneCenterEnable ? "5" : "4";
                          break;
                        case "R3":
                        case "Head of Subsidiary":
                        case "GCFO":
                          routingOrder = oneCenterEnable ? "4" : "3";
                          break;
                        case "GCEO":
                        case "MD":
                          routingOrder = oneCenterEnable ? "5" : "4";
                          break;
                        case "GCOO":
                          routingOrder = oneCenterEnable ? "4" : "3";
                          break;
                        case "COO":
                          routingOrder =
                            selectedOption === "GCFO/GCOO"
                              ? oneCenterEnable
                                ? "4"
                                : "3"
                              : oneCenterEnable
                                ? "5"
                                : "4";
                          break;
                        default:
                          routingOrder = "";
                      }
                      setFieldValue(`reviewers[${validIndex}].routingOrder`, routingOrder);

                      processedDesignations.add(approver.designation);
                      validIndex++;
                    } else if (!allowedDesignations.includes(approver.designation)) {
                      console.timeLog("else approver", approver);
                      setFieldValue(`reviewers[${validIndex}].designation`, approver.designation);
                      setFieldValue(`reviewers[${validIndex}].name`, approver.userName);
                      setFieldValue(`reviewers[${validIndex}].email`, approver.userEmail);

                      let routingOrder;
                      switch (approver.designation) {
                        case "R1":
                          routingOrder = oneCenterEnable ? "3" : "2";
                          break;
                        case "R2":
                          routingOrder =
                            selectedOption === "airportManager"
                              ? oneCenterEnable
                                ? "4"
                                : "3"
                              : oneCenterEnable
                                ? "3"
                                : "2";
                          break;
                        case "Airport Manager":
                          routingOrder = oneCenterEnable ? "5" : "4";
                          break;
                        case "R3":
                        case "Head of Subsidiary":
                        case "GCFO":
                          routingOrder = oneCenterEnable ? "4" : "3";
                          break;
                        case "GCEO":
                        case "MD":
                          routingOrder = oneCenterEnable ? "5" : "4";
                          break;
                        case "GCOO":
                          routingOrder = oneCenterEnable ? "4" : "3";
                          break;
                        case "COO":
                          routingOrder =
                            selectedOption === "GCFO/GCOO"
                              ? oneCenterEnable
                                ? "4"
                                : "3"
                              : oneCenterEnable
                                ? "5"
                                : "4";
                          break;
                        default:
                          routingOrder = "";
                      }
                      setFieldValue(`reviewers[${validIndex}].routingOrder`, routingOrder);

                      processedDesignations.add(approver.designation);
                      validIndex++;
                    }
                  });
                });
              }
            }, [approverData, reviewerCount, oneCenterEnable, selectedOption, selectRole]);

            useEffect(() => {
              if (watcherList && watcherList.length > 0) {
                const technicalIndex = watcherList.length + 1;
                watcherList.forEach((watcher: any, idx: number) => {
                  setFieldValue(`watchers[${1 + idx}].role`, "PCD");
                  setFieldValue(`watchers[${1 + idx}].userName`, watcher.userName);
                  setFieldValue(`watchers[${1 + idx}].userEmail`, watcher.userEmail);
                });
                setFieldValue(`watchers[${technicalIndex}].role`, "Technical");
              } else {
                watcherList.forEach((_: any, idx: number) => {
                  setFieldValue(`watchers[${1 + idx}].role`, "");
                  setFieldValue(`watchers[${1 + idx}].userName`, "");
                  setFieldValue(`watchers[${1 + idx}].userEmail`, "");
                });
              }
            }, [watcherList]);

            useEffect(() => {
              if (templateList) {
                templateList.forEach((name: any, index: any) => {
                  setFieldValue(`templateName`, name.templateName);
                  setFieldValue(`templateId`, name.templateId);
                });
              }
            }, [templateList]);
            useEffect(() => {
              if (envelopId) {
                const technicalIndex = watcherList.length + 1;
                const formattedCostValue =
                  costValue && !isNaN(parseFloat(costValue))
                    ? new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(parseFloat(costValue))
                    : "0";
                const watcherDetailsFinance = watchers.filter((item: any) => item.role === "Finance");
                const watcherDetailsTechnical = watchers.filter((item: any) => item.role === "Technical");
                const watcherDetailsPCD = watcherList.filter((item: any) => item.role === "PCD");
                const watcherDetailsOthers = watchers.filter((item: any) => item.role === "Others");
                watchers.forEach((item: any) => {
                  if (item.role === "R1") {
                    props?.setFieldValue(`watcherOne.userName`, item?.name);
                    props?.setFieldValue(`watcherOne.userEmail`, item?.emailAddress);
                  }
                });
                watcherDetailsFinance.forEach((item: any) => {
                  props?.setFieldValue(`watchers[0].userName`, item?.name);
                  props?.setFieldValue(`watchers[0].userEmail`, item?.emailAddress);
                });
                watcherDetailsPCD.forEach((item: any, i: number) => {
                  props?.setFieldValue(`watchers[${1 + i}].userName`, item?.name);
                  props?.setFieldValue(`watchers[${1 + i}].userEmail`, item?.emailAddress);
                  props?.setFieldValue(`watchers[${1 + i}].role`, "PCD");
                });
                watcherDetailsTechnical.forEach((item: any) => {
                  props?.setFieldValue(`watchers[${technicalIndex}].userName`, item?.name);
                  props?.setFieldValue(`watchers[${technicalIndex}].userEmail`, item?.emailAddress);
                });
                watcherDetailsOthers.forEach((item: any, i: number) => {
                  props?.setFieldValue(`watchers[${technicalIndex + 1 + i}].userName`, item?.name);
                  props?.setFieldValue(`watchers[${technicalIndex + 1 + i}].userEmail`, item?.emailAddress);
                });
                props.setFieldValue("totalCost", formattedCost || formattedCostValue);
              }
            }, [envelopId, selectedDesignation, formattedCost, approverDetails, watcherList]);

            useEffect(() => {
              const managerSigners = signerDetail.filter(
                (item: any) =>
                  item.designation === "Manager" ||
                  item.designation === "Senior Manager" ||
                  item.designation === "APC Secretariat" ||
                  item.designation === "Senior Executive" ||
                  item.designation === "Officer" ||
                  item.designation === "Executive"
              );
              if (props.values?.signers?.length <= 1 && props.values?.signers?.[0]?.name === "") {
                if (envelopId && selectedDesignation?.length > 0) {
                  selectedDesignation.forEach((item: any, index: number) => {
                    if (props.values.signers[index] && draftApprovalAuthority === selectRole) {
                      const designationedSigners = managerSigners.map((item: any) => ({
                        name: item.name,
                        email: item.emailAddress,
                        subsidiary: item.subsidiary,
                        division: item.division,
                        designation: item.designation,
                      }));
                      props.setFieldValue("signers", designationedSigners);
                    }
                  });
                }
              }
            }, [
              JSON.stringify(signerDetail),
              JSON.stringify(props.values.signers),
              draftApprovalAuthority,
              selectRole,
            ]);

            const prevRole = useRef<string | null>(null);
            useEffect(() => {
              if (
                !(
                  props.values?.oneCenter?.length === 1 &&
                  (props.values?.oneCenter?.[0].name === "" || props.values?.oneCenter?.[0].email === "")
                ) &&
                prevRole.current === selectRole
              )
                return;
              if (envelopId && draftApprovalAuthority === selectRole) {
                const oneStopSigners = signerDetail.filter(
                  (signer: any) =>
                    signer?.designation === "One Stop Centre" ||
                    signer?.designation === "One Stop Centre, PCD" ||
                    signer?.designation === "Secretariat, PCD" ||
                    signer?.designation === "Secratariat, PCD"
                );

                const draftOneStopCenterDetails = oneStopSigners.map((signer: any) => ({
                  designation: signer?.designation,
                  name: signer?.userName || signer?.name,
                  email: signer?.userEmail || signer?.email || signer?.emailAddress,
                }));
                props.setFieldValue("oneCenter", draftOneStopCenterDetails);
              } else {
                const filteredOneCentre = oneCentreData.map((signer: any) => ({
                  designation:
                    signer?.designation === "One Stop Centre, PCD" ? "Secretariat, PCD" : signer?.designation,
                  name: signer?.userName || signer?.name,
                  email: signer?.userEmail || signer?.email || signer?.emailAddress,
                }));
                props.setFieldValue("oneCenter", filteredOneCentre);
              }
              prevRole.current = selectRole;
            }, [
              draftApprovalAuthority,
              selectRole,
              JSON.stringify(props.values?.oneCenter),
              JSON.stringify(oneCentreData),
            ]);

            useEffect(() => {
              if (deaprtmentRoles && deaprtmentRoles?.length > 0) {
                setFieldValue(`watchers[0].role`, deaprtmentRoles[0]);
              }
            }, [deaprtmentRoles, setFieldValue, currentStep === 3]);

            useEffect(() => {
              const technicalIndex = watcherList.length + 1;
              values?.watchers?.forEach((watcher: any, index: any) => {
                if (index === 0) return;
                if (index >= 1 && index <= watcherList.length) return;
                if (index === technicalIndex) return;
                if (watcher.role !== "Others") {
                  setFieldValue(`watchers[${index}].role`, "Others", false);
                }
              });
            }, [values?.watchers, watcherList, setFieldValue]);

            useEffect(() => {
              if (!envelopId && values.subsidiary) {
                setFieldValue("division", "");
              }
              if (envelopId) {
                setFieldValue("division", defaultDivisionName);
              }
            }, [values.subsidiary, divisionData]);

            useEffect(() => {
              if (currentStep === 3) {
                setProjectName(props.values.projectTitle);
              }
            }, [props.values.projectTitle, currentStep === 3]);

            const subsidiaryName = props?.values?.subsidiary?.includes("/")
              ? props.values.subsidiary.split("/")[1]
              : props?.values?.subsidiary;
            const divisionName = props?.values?.division;
            setDivisionName(divisionName);
            setSubsidiaryName(subsidiaryName);
            const subsidiary = props.values.subsidiary;
            const subsidiaryId = subsidiary?.split("/")[0];
            setSubsidiaryId(subsidiaryId);

            if (props?.values?.signers?.length > 0) {
              const firstSignerSubsidiary = props?.values?.signers[0]?.subsidiary;
              const spaSubsidiaryName = firstSignerSubsidiary.split("/")[1];
              setSpaSubsidiaryName(spaSubsidiaryName);
            }

            const spaDivisionName = props?.values?.signers[0]?.division;
            setSpaDivisionName(spaDivisionName);
            const spaSubsidiary = props?.values?.signers[0]?.subsidiary;
            const spaSubsidiaryId = spaSubsidiary?.split("/")[0];
            setSpaSubsidiaryId(spaSubsidiaryId);
            let tableData = [{ ...props?.values?.signers }, { ...props?.values?.reviewers }];
            useEffect(() => {}, [currentStep]);
            const { commencementDate, completionDate } = props.values;

            const combinedWatchers = props?.values?.watchers;

            const sortedWatchers = combinedWatchers
              ?.map((item: any, i: number) => {
                const technicalIndex = watcherList.length + 1;
                let role = "Others";
                if (i === 0) role = "Finance";
                else if (i >= 1 && i <= watcherList.length) role = "PCD";
                else if (i === technicalIndex) role = "Technical";
                return { ...item, role };
              })
              .filter((item: any) => item.userName && item.userEmail);

            useEffect(() => {
              if (currentStep === 3)
                props?.values?.watchers?.forEach((val: any) => {
                  const email = val.userEmail;
                  if (email && props.errors) {
                    const domain = email.split("@")[1];
                    if (allowedDomainsAll.includes(domain)) {
                      setCheckMail(email);
                    }
                  }
                });
            }, [props?.values?.watchers, props.errors]);
            const hasAnyFieldFilled = (values: any, docsList: any[], currentStep: number) => {
              if (currentStep == 1) {
                return docsList?.length > 0;
              }
              if (currentStep == 2) {
                return (
                  values?.signers?.some((signer: any) => signer?.name || signer?.email || signer?.role) ||
                  values?.reviewers?.some((reviewer: any) => reviewer?.name || reviewer?.email || reviewer?.role)
                );
              }

              if (currentStep == 3) {
                return values?.watchers?.some((watcher: any) => watcher?.name || watcher?.email || watcher?.role);
              }
              if (values?.projectTitle.length > 0) return true;
              if (values?.projectSummary.length > 0) return true;
              if (values?.subsidiary.length > 0) return true;
              if (values?.procurementSummary.length > 0) return true;
              if (values?.recommendedVendor.length > 0) return true;
              if (values?.contractValue.length > 0) return true;
              if (values?.contractPeriod.length > 0) return true;
              return false;
            };

            const hasFilledRequiredFields = (values: any) => {
              if (currentStep === 3) {
                const technicalIndex = watcherList.length + 1;
                const finance = values.watchers?.[0];
                const technical = values.watchers?.[technicalIndex];

                return finance?.userName && finance?.userEmail && technical?.userName && technical?.userEmail;
              }
              return false;
            };

            return (
              <Form
                id="step1"
                layout="vertical"
                onFinish={props.handleSubmit}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && currentStep === 1) e.preventDefault();
                }}
              >
                {selectedDocumentReview && (
                  <PDFViewer
                    show={true}
                    title={"View Document"}
                    subTitle={""}
                    setShow={() => setSelectedDocumentReview("")}
                    url={selectedDocumentReview}
                  />
                )}
                <Steps
                  current={currentStep}
                  items={stepItems}
                  labelPlacement="vertical"
                  size="default"
                  responsive
                />
                <div style={{ marginTop: 16 }}>
                  <div>
                    <div id="step1">
                      {currentStep === 0 && (
                        <>
                          <div style={{ width: "70%" }}>
                            <Row gutter={16}>
                              <Col span={12}>
                                <Form.Item label="Budget">
                                  <Field name="budgetDrop">
                                    {({ field, form }: FieldProps) => {
                                      const displayValue = field.value || (envelopId ? budgetValue : undefined);
                                      setBudgetValue(displayValue);
                                      return (
                                        <Select
                                          placeholder="Select the Budget"
                                          value={displayValue || undefined}
                                          onChange={(value) => form.setFieldValue("budgetDrop", value)}
                                          onBlur={() => form.setFieldTouched("budgetDrop", true)}
                                          status={(form.touched.budgetDrop && form.errors.budgetDrop && "error") || ""}
                                        >
                                          {spaBudget.map((item: any, i: number) => (
                                            <Select.Option
                                              key={i}
                                              value={item}
                                            >
                                              {item}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      );
                                    }}
                                  </Field>
                                  <div>
                                    <Typography.Text type="danger">
                                      <ErrorMessage name="budgetDrop" />
                                    </Typography.Text>
                                  </div>
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item label="SPA Types">
                                  <Field name="paperDrop">
                                    {({ field, form }: FieldProps) => {
                                      const displayValue = field.value || (envelopId ? paperValue : undefined);
                                      setPaperValue(displayValue);
                                      return (
                                        <Select
                                          placeholder="Select the SPA Types"
                                          value={displayValue || undefined}
                                          onChange={(value) => form.setFieldValue("paperDrop", value)}
                                          onBlur={() => form.setFieldTouched("paperDrop", true)}
                                          status={(form.touched.paperDrop && form.errors.paperDrop && "error") || ""}
                                        >
                                          {spaPaper.map((item: any, i: number) => (
                                            <Select.Option
                                              key={i}
                                              value={item}
                                            >
                                              {item}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      );
                                    }}
                                  </Field>
                                  <div>
                                    <Typography.Text type="danger">
                                      <ErrorMessage name="paperDrop" />
                                    </Typography.Text>
                                  </div>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                          {(props.values.budgetDrop || paperValue) && (props.values.paperDrop || budgetValue) && (
                            <div style={{ width: "70%" }}>
                              <Row gutter={24}>
                                {props.values.templateId && (
                                  <Col
                                    md={24}
                                    xs={24}
                                  >
                                    <Form.Item label="Project Name">
                                      <Field name={`projectTitle`}>
                                        {({ field }: FieldProps) => (
                                          <Input.TextArea
                                            showCount
                                            maxLength={5000}
                                            style={{ height: "110px" }}
                                            {...field}
                                            {...(field.value && {
                                              value: field.value,
                                            })}
                                            status={
                                              (props.touched.projectTitle && props.errors.projectTitle && "error") || ""
                                            }
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`projectTitle`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                )}
                                {props.values.templateId && (
                                  <Col md={24}>
                                    <Form.Item label="Project Summary">
                                      <Field name={`projectSummary`}>
                                        {({ field }: FieldProps) => (
                                          <Input.TextArea
                                            style={{ height: "110px" }}
                                            {...field}
                                            {...(field.value && {
                                              value: field.value,
                                            })}
                                            status={
                                              (props.touched.projectSummary &&
                                                props.errors.projectSummary &&
                                                "error") ||
                                              ""
                                            }
                                            showCount
                                            maxLength={50000}
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`projectSummary`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                )}
                                {props.values.templateId && (
                                  <EqualCol>
                                    <Form.Item label={"Subsidiary/Division"}>
                                      <Field name={`subsidiary`}>
                                        {({ field }: FieldProps) => (
                                          <Select
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            showSearch
                                            value={field.value}
                                            filterOption={(input, option: any) =>
                                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            onBlur={() => props.setFieldTouched("subsidiary", true)}
                                            onChange={(e) => {
                                              props.setFieldValue("subsidiary", e);
                                            }}
                                            status={
                                              (props.touched.subsidiary && props.errors.subsidiary && "error") || ""
                                            }
                                          >
                                            {subsidiaryData &&
                                              subsidiaryData.map((values: any, index: number) => (
                                                <Select.Option
                                                  value={`${values.subsidiaryId}/${values.name}`}
                                                  key={`${index}-${values.subsidiaryId}`}
                                                >
                                                  {values.name}
                                                </Select.Option>
                                              ))}
                                          </Select>
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`subsidiary`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </EqualCol>
                                )}
                                {props.values.templateId && (
                                  <EqualCol>
                                    <Form.Item
                                      className="contract-value"
                                      label={
                                        <>
                                          <div style={{ marginRight: 10 }}>
                                            Budget Amount/Pre-Tender Estimate (PTE)
                                            <Popover
                                              overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                              placement="topRight"
                                              content={
                                                <p>
                                                  Please add PTE for tender/quotation. If non related, add budget amount
                                                </p>
                                              }
                                            >
                                              <Icon
                                                icon="bi:info-circle"
                                                style={{ color: styles.strawberry, marginLeft: 5, fontSize: 16 }}
                                              />
                                            </Popover>{" "}
                                          </div>
                                        </>
                                      }
                                    >
                                      <Field name="currencyCode">
                                        {({ field, form }: FieldProps) => (
                                          <Input.Group
                                            compact
                                            style={{ display: "flex", alignItems: "center" }}
                                          >
                                            <Select
                                              getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                              showSearch
                                              value={!field.value ? "MYR" : field.value}
                                              style={{ flex: "30%" }}
                                              onChange={(value) => form.setFieldValue("currencyCode", value)}
                                            >
                                              {currencyOptions(currencyData, currency)}
                                            </Select>
                                            <Field name="totalCost">
                                              {({ field, form }: FieldProps) => {
                                                return (
                                                  <Input
                                                    style={{ flex: "100%", marginLeft: "8px" }}
                                                    {...field}
                                                    value={field.value}
                                                    status={
                                                      (form.touched?.totalCost && form.errors?.totalCost && "error") ||
                                                      ""
                                                    }
                                                    onChange={(e) => {
                                                      const { value } = e.target;
                                                      const rawValue = value.replace(/,/g, "");
                                                      if (/^\d*\.?\d{0,2}$/.test(rawValue)) {
                                                        form.setFieldValue("totalCost", rawValue);
                                                      }
                                                    }}
                                                    onBlur={() => {
                                                      props.setFieldTouched("totalCost", true);
                                                      if (field.value) {
                                                        const formattedValue = new Intl.NumberFormat("en-US", {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        }).format(parseFloat(field.value));
                                                        form.setFieldValue("totalCost", formattedValue);
                                                        setCostValue(field?.value);
                                                      }
                                                    }}
                                                  />
                                                );
                                              }}
                                            </Field>
                                          </Input.Group>
                                        )}
                                      </Field>

                                      <Typography.Text type="danger">
                                        <ErrorMessage name="currencyCode" />
                                      </Typography.Text>

                                      <Typography.Text type="danger">
                                        <ErrorMessage name="totalCost" />
                                      </Typography.Text>
                                    </Form.Item>
                                  </EqualCol>
                                )}
                                {props.values.templateId && (
                                  <EqualCol>
                                    <Form.Item label={"Cost Centre"}>
                                      <Field name={`division`}>
                                        {({ field }: FieldProps) => {
                                          return (
                                            <Select
                                              getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                              disabled={props.values.subsidiary ? false : true}
                                              showSearch
                                              value={field.value}
                                              filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                              }
                                              onBlur={() => props.setFieldTouched("division", true)}
                                              onChange={(e) => {
                                                props.setFieldValue("division", e);
                                              }}
                                              status={
                                                (props.touched.division && props.errors.division && "error") || ""
                                              }
                                            >
                                              {divisionData &&
                                                divisionData.map((item: any, index: number) => {
                                                  return (
                                                    <Select.Option
                                                      value={item.division}
                                                      key={`${index}-${item.uniqueId}`}
                                                    >
                                                      {item.division}
                                                    </Select.Option>
                                                  );
                                                })}
                                            </Select>
                                          );
                                        }}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`division`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </EqualCol>
                                )}

                                <div style={{ width: "100%" }}>
                                  <h3>
                                    A. Information on Procurement Process
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Select one from the list </p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>{" "}
                                  </h3>
                                  <Radio.Group
                                    onChange={(e) => {
                                      handleRadioChange(e.target.value);
                                      props.setFieldValue("procurementProcess", e.target.value);
                                    }}
                                    value={selectedPoints}
                                  >
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1a.</span>
                                      <Radio value="1a">{procurementProcess["1a"]}</Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1b.</span>
                                      <Radio value="1b">{procurementProcess["1b"]}</Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1c.</span>
                                      <Radio value="1c">{procurementProcess["1c"]}</Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1d.</span>
                                      <Radio value="1d">{procurementProcess["1d"]}</Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1e.</span>
                                      <Radio value="1e">{procurementProcess["1e"]}</Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1f.</span>
                                      <Radio value="1f">
                                        <span>
                                          Direct Appointment (Based on Permissible Criteria) - Continuation of Contract
                                          with approved Vendor to another Budget Owner - A different budget owner
                                          appoints the same contractor or service provider who is currently engaged
                                          under an existing contract, to carry out equivalent works or services that
                                          fall within the scope or "boundary of that existing contract such as location,
                                          scope of work, etc, subject to the following conditions:
                                          <ul style={{ marginTop: "4px", paddingLeft: "0", listStyle: "none" }}>
                                            <li>● The main contract must have been competitively tendered</li>
                                            <li>
                                              ● The extension is only applicable within six (6) months from the
                                              commencement date of the main contract.
                                            </li>
                                            <li>● The extension is allowed once only to another Budget Owner</li>
                                          </ul>
                                        </span>
                                      </Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1g.</span>
                                      <Radio value="1g">{procurementProcess["1g"]}</Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1h.</span>
                                      <Radio value="1h">{procurementProcess["1h"]}</Radio>
                                    </div>
                                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "start" }}>
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>1i.</span>
                                      <Radio value="1i">{procurementProcess["1i"]}</Radio>
                                    </div>
                                    <div
                                      style={{
                                        marginBottom: "30px",
                                        marginLeft: "7px",
                                        display: "flex",
                                        alignItems: "start",
                                      }}
                                    >
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>2.</span>
                                      <Radio value="2">{procurementProcess["2"]}</Radio>
                                    </div>
                                    <div
                                      style={{
                                        marginBottom: "30px",
                                        marginLeft: "7px",
                                        display: "flex",
                                        alignItems: "start",
                                      }}
                                    >
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>3.</span>
                                      <Radio value="3">{procurementProcess["3"]}</Radio>
                                    </div>
                                    <div
                                      style={{
                                        marginBottom: "30px",
                                        marginLeft: "7px",
                                        display: "flex",
                                        alignItems: "start",
                                      }}
                                    >
                                      <span style={{ marginRight: "8px", color: "black", fontSize: "16px" }}>4.</span>
                                      <Radio value="4">{procurementProcess["4"]}</Radio>
                                    </div>
                                  </Radio.Group>
                                  {/* </Field>
                              </Form.Item> */}
                                </div>
                                <div style={{ width: "100%" }}>
                                  <h3>
                                    B. Summary of the Procurement (e.g Background, Evaluation & Justification){" "}
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={
                                        <p>
                                          Provide Summary for background, Evaluation and Justification and Budget
                                          Status{" "}
                                        </p>
                                      }
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>{" "}
                                  </h3>
                                  <Col md={24}>
                                    <Form.Item>
                                      <Field name={`procurementSummary`}>
                                        {({ field, form }: FieldProps) => {
                                          return (
                                            <RichTextInput
                                              value={field.value}
                                              onChange={(val) => {
                                                form.setFieldTouched("procurementSummary", true, false);
                                                form.setFieldValue("procurementSummary", isEditorEmpty(val) ? "" : val);
                                              }}
                                              readOnly={form.values.messageLock}
                                              maxLength={50000}
                                              height={100}
                                              showCount
                                            />
                                          );
                                        }}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`procurementSummary`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                </div>
                                <div style={{ width: "100%" }}>
                                  <h3>
                                    C. Recommendation
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Provide recommendation Bidder / Vendor </p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>
                                  </h3>
                                  <Col>
                                    <Form.Item label="Recommended Bidder/Vendor">
                                      <Field name={`recommendedVendor`}>
                                        {({ field }: FieldProps) => (
                                          <Input.TextArea
                                            {...field}
                                            style={{
                                              height: "60px",
                                              cursor: props.values.messageLock ? "not-allowed" : "auto",
                                            }}
                                            rows={8}
                                            showCount
                                            maxLength={50000}
                                            readOnly={props.values.messageLock}
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`recommendedVendor`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  <Col md={24}>
                                    <Form.Item label="Proposed Contract Value">
                                      <Field name="contractValue">
                                        {({ field }: FieldProps) => (
                                          <Input.TextArea
                                            {...field}
                                            style={{
                                              height: "60px",
                                              cursor: props.values.messageLock ? "not-allowed" : "auto",
                                            }}
                                            rows={8}
                                            showCount
                                            maxLength={5000}
                                            readOnly={props.values.messageLock}
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`contractValue`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  <Col>
                                    <Form.Item label="Proposed Contract Period">
                                      <Field name={`contractPeriod`}>
                                        {({ field }: FieldProps) => (
                                          <Input.TextArea
                                            {...field}
                                            style={{
                                              height: "60px",
                                              cursor: props.values.messageLock ? "not-allowed" : "auto",
                                            }}
                                            rows={8}
                                            showCount
                                            maxLength={5000}
                                            readOnly={props.values.messageLock}
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`contractPeriod`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                </div>
                              </Row>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div id="step1">
                      {currentStep === 1 && (
                        <Row style={{ marginBottom: 16, display: "block", width: "100%" }}>
                          <Col
                            xs={24}
                            md={24}
                          >
                            <div id="loaDocuments">
                              <Typography.Title
                                level={4}
                                style={{ marginBottom: styles.whitesapce3 }}
                              >
                                Project Documents
                                <Popover
                                  overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                  placement="topLeft"
                                  content={
                                    <>
                                      <Typography.Title level={5}>Direct Appointment</Typography.Title>
                                      <ul>
                                        <li>
                                          Attach letter of Authorisation from principal for permissible criteria under
                                          OEM/Sole Proprietorship/Sole Agency (if related){" "}
                                        </li>
                                        <li>Direct Appointment checklist</li>
                                        <li>
                                          Declaration on Interest and Non-Disclosure duly completed and signed by the
                                          OEL and Recommenders{" "}
                                        </li>
                                        <li>RPT Form duly completed and signed by vendor</li>
                                        <li>Declaration of Non-Collusion (DNC) duly completed and signed by vendor </li>
                                        <li>Budget Status form completed and signed by BP Finance </li>
                                        <li>Valid and comprehensive quotation/proposal from Vendor</li>
                                      </ul>
                                      <Typography.Title level={5}>Tender</Typography.Title>
                                      <ul>
                                        <li>NDA OEL & R1</li>
                                        <li>Budget Status form completed and signed by BP</li>
                                        <li>Evaluation reports</li>
                                      </ul>
                                    </>
                                  }
                                >
                                  <Icon
                                    icon="bi:info-circle"
                                    style={{ color: styles.strawberry, marginLeft: 5 }}
                                  />
                                </Popover>
                              </Typography.Title>
                            </div>
                          </Col>
                          <Col
                            xs={24}
                            md={24}
                            style={{ marginBottom: 16 }}
                          >
                            <Typography.Text>
                              <span>
                                <Icon
                                  icon="arcticons:documents"
                                  fontSize={24}
                                  style={{ color: styles.strawberry }}
                                />
                              </span>
                              Please upload your files
                            </Typography.Text>
                          </Col>
                          <Col
                            md={24}
                            style={{ width: "100%" }}
                          >
                            <Row style={{ marginTop: styles.whitesapce3, display: "flex", width: "100%" }}>
                              <Col
                                xs={24}
                                md={12}
                              >
                                <Form.Item
                                  style={{ width: "100%" }}
                                  label=""
                                >
                                  <Upload.Dragger
                                    style={{
                                      borderRadius: 10,
                                      padding: 30,
                                    }}
                                    name="projects"
                                    showUploadList={false}
                                    {...uploadProps}
                                    multiple={false}
                                    accept=".pdf"
                                  >
                                    <Image
                                      src={upload}
                                      preview={false}
                                    />
                                    <br />
                                    <Typography.Text>
                                      Only PDF files are allowed
                                      <br />
                                    </Typography.Text>
                                    <Typography.Text style={{ color: styles.strawberry }}>
                                      (Maximum File Size: 40 MB)
                                      <br />
                                    </Typography.Text>
                                    <Typography.Text style={{ color: styles.strawberry }}>
                                      (Maximum Files: 10)
                                    </Typography.Text>
                                    <Typography.Text
                                      className="ant-upload-text"
                                      style={{
                                        display: "flex",
                                        marginBlock: styles.whitespace2,
                                        justifyContent: "center",
                                      }}
                                    >
                                      Click or drag file to this area to upload
                                    </Typography.Text>
                                  </Upload.Dragger>
                                </Form.Item>
                              </Col>
                              <Col
                                xs={24}
                                md={12}
                              >
                                <div style={{ width: "100%" }}>
                                  {map(docsList, (item: any, index: number) => {
                                    return (
                                      <div
                                        style={{ marginLeft: styles.whitespace3 }}
                                        key={index}
                                      >
                                        <Space
                                          style={{
                                            marginBottom: styles.whitespace1,
                                          }}
                                        >
                                          <Icon
                                            icon="ph:file-pdf"
                                            inline
                                            fontSize={24}
                                            className="doc-icon"
                                            style={{ marginRight: 8 }}
                                          />
                                          <Typography.Title
                                            style={{ cursor: "pointer", fontSize: "12px" }}
                                            onClick={() => onPreviewDoument(item)}
                                            level={5}
                                          >
                                            {item.name || item.documentName}
                                          </Typography.Title>
                                          {id && (
                                            <Icon
                                              icon="carbon:edit"
                                              inline
                                              className="doc-icon"
                                              fontSize={24}
                                              style={{
                                                marginLeft: 8,
                                                marginRight: 8,
                                              }}
                                              cursor="pointer"
                                            />
                                          )}
                                          <Icon
                                            icon="ic:outline-delete"
                                            inline
                                            className="doc-icon"
                                            fontSize={20}
                                            style={{
                                              marginLeft: 8,
                                              marginRight: 8,
                                            }}
                                            cursor="pointer"
                                            onClick={() => handleRemove(item)}
                                          />
                                          {loadingDocId === item.documentId && (
                                            <Icon
                                              icon="eos-icons:bubble-loading"
                                              inline
                                              className="doc-icon"
                                              fontSize={24}
                                              style={{
                                                marginLeft: 12,
                                                marginRight: 12,
                                              }}
                                            />
                                          )}
                                        </Space>
                                      </div>
                                    );
                                  })}
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col style={{ width: "100%" }}>
                            <Row style={{ width: "100%" }}>
                              {selectDocument && (
                                <Col
                                  xs={24}
                                  md={24}
                                  style={{ margin: "20px 0px" }}
                                >
                                  <Icon
                                    icon="ph:file-pdf"
                                    inline
                                    fontSize={24}
                                    className="doc-icon"
                                    cursor="pointer"
                                    style={{ marginRight: 8 }}
                                    onClick={() => onPreviewDoument(selectDocument)}
                                  />{" "}
                                  {selectDocument?.name}
                                </Col>
                              )}
                              <Col
                                xs={24}
                                md={20}
                                style={{
                                  display: "flex",
                                  height: 500,
                                  justifyContent: "center",
                                  background: "#f2f5ff",
                                  overflow: "scroll",
                                  padding: "5px",
                                }}
                              >
                                {selectDocument ? (
                                  <>
                                    <Row>
                                      <PDFView
                                        show={true}
                                        title={"View Document"}
                                        subTitle={""}
                                        setShow={() => setSelectedDocument("")}
                                        url={selectedDocument}
                                        scale={scale}
                                      />
                                    </Row>
                                  </>
                                ) : (
                                  <Row
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Icon
                                      icon="ph:file-pdf"
                                      inline
                                      fontSize={24}
                                      className="doc-icon"
                                      style={{ marginRight: 8, color: "#919191" }}
                                    />
                                    <Col style={{ color: "#919191" }}>No documents to preview</Col>
                                  </Row>
                                )}
                              </Col>
                              <Col
                                xs={24}
                                md={20}
                              >
                                {selectDocument && (
                                  <Row style={{ marginTop: 10, flexDirection: "row-reverse", gap: 10 }}>
                                    <Button
                                      key="zoomIn"
                                      onClick={zoomIn}
                                    >
                                      <Icon
                                        icon="akar-icons:plus"
                                        inline
                                      />
                                    </Button>
                                    <Button
                                      key="zoomOut"
                                      onClick={zoomOut}
                                    >
                                      <Icon
                                        icon="akar-icons:minus"
                                        inline
                                      />
                                    </Button>
                                  </Row>
                                )}
                              </Col>
                            </Row>
                          </Col>
                          <Col
                            id="documentLinks"
                            style={{ width: "100%", marginTop: "20px" }}
                          >
                            <Row style={{ width: "100%" }}>
                              <Typography.Title
                                level={4}
                                style={{ marginBottom: styles.whitesapce3 }}
                              >
                                Additional Document Details
                              </Typography.Title>
                              <Popover
                                overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                placement="topLeft"
                                content={
                                  <>
                                    <ul>
                                      <li>
                                        Please provide editor access and paste the link to the shared editable file
                                        (e.g., Google Doc, Google Sheet, PDF, etc.) for live comments/review.
                                      </li>
                                      <li>
                                        Please ensure relevant Approver/Recommender/Watcher has access to the link file
                                      </li>
                                    </ul>
                                  </>
                                }
                              >
                                <Icon
                                  icon="bi:info-circle"
                                  style={{ color: styles.strawberry, marginLeft: 5, marginTop: 5, fontSize: 20 }}
                                />
                              </Popover>
                            </Row>
                            <Col
                              xs={24}
                              md={24}
                              style={{ marginBottom: 16 }}
                            >
                              <Typography.Text>
                                <span>
                                  <Icon
                                    icon="arcticons:documents"
                                    fontSize={24}
                                    style={{ color: styles.strawberry }}
                                  />
                                </span>
                                Please enter your document details
                              </Typography.Text>
                            </Col>
                            {(props.values.documentLinkDetails ?? [{ name: "", url: "" }]).map((event: any, i: any) => {
                              return (
                                <Row
                                  gutter={[16, 16]}
                                  key={i}
                                >
                                  <Col
                                    style={{ alignSelf: "end" }}
                                    span={10}
                                  >
                                    <Form.Item label="Document Name">
                                      <Field name={`documentLinkDetails[${i}].name`}>
                                        {({ field }: FieldProps) => {
                                          return (
                                            <Input
                                              placeholder="Enter the Document Name"
                                              {...field}
                                              onBlur={() =>
                                                props.setFieldTouched(`documentLinkDetails[${i}].name`, true)
                                              }
                                            />
                                          );
                                        }}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`documentLinkDetails[${i}].name`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  <Col
                                    style={{ alignSelf: "end" }}
                                    span={10}
                                  >
                                    <Form.Item label="Document Link">
                                      <Field name={`documentLinkDetails[${i}].url`}>
                                        {({ field }: FieldProps) => {
                                          return (
                                            <Input
                                              placeholder="Enter the Document link"
                                              {...field}
                                              onBlur={() =>
                                                props.setFieldTouched(`documentLinkDetails[${i}].url`, true)
                                              }
                                            />
                                          );
                                        }}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`documentLinkDetails[${i}].url`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  <Col>
                                    <Form.Item label=" ">
                                      <Button
                                        type="link"
                                        danger
                                        disabled={(props?.values?.documentLinkDetails ?? []).length === 1}
                                        onClick={() => {
                                          const docs = [...props.values.documentLinkDetails];
                                          docs.splice(i, 1);
                                          const newTouched = { ...props.touched };
                                          delete newTouched.documentLinkDetails;

                                          props.setTouched(newTouched);
                                          props.setValues({
                                            ...props.values,
                                            documentLinkDetails: docs.length > 0 ? docs : [{ name: "", url: "" }],
                                          });
                                        }}
                                      >
                                        <Icon
                                          icon="fluent:delete-16-regular"
                                          style={{
                                            color: styles.strawberry,
                                            cursor: "pointer",
                                            fontSize: 20,
                                          }}
                                        />
                                      </Button>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              );
                            })}

                            <Row>
                              <Col
                                span={22}
                                style={{ textAlign: "right", marginBottom: 16 }}
                              >
                                <Button
                                  disabled={
                                    !props?.values?.documentLinkDetails?.every((doc: any) => doc?.url?.trim() !== "")
                                  }
                                  type="text"
                                  icon={<Icon icon="akar-icons:plus" />}
                                  onClick={() => {
                                    let documentLinkDetails = [
                                      ...props.values.documentLinkDetails,
                                      { name: "", url: "" },
                                    ];
                                    const newTouched = { ...props.touched };
                                    delete newTouched.documentLinkDetails;

                                    props.setTouched(newTouched);
                                    props.setValues({
                                      ...props.values,
                                      documentLinkDetails: documentLinkDetails,
                                    });
                                  }}
                                >
                                  Add Another
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )}
                    </div>
                    <div id="step2">
                      {currentStep === 2 && (
                        <>
                          <div style={{ margin: "30px 0px", width: "80%" }}>
                            <Typography.Title
                              level={4}
                              style={{ marginBottom: "25px" }}
                            >
                              Approval Authority
                              <Popover
                                overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                placement="topLeft"
                                content={<p>Select Approval authority based on GALOA </p>}
                              >
                                <Icon
                                  icon="bi:info-circle"
                                  style={{ color: styles.strawberry, marginLeft: 5 }}
                                />
                              </Popover>
                            </Typography.Title>
                            <div
                              style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                              className="row"
                            >
                              <div
                                style={{ margin: "0px 0px", display: "flex", alignItems: "center" }}
                                className="col"
                              >
                                <label style={{ display: "flex" }}>
                                  <input
                                    style={{ margin: "0px 8px" }}
                                    type="radio"
                                    name="radioGroup"
                                    value="MD/GCEO"
                                    checked={selectedOption === "MD/GCEO"}
                                    onChange={handleOptionChange}
                                  />
                                  MD/GCEO
                                </label>
                                <Popover
                                  overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                  placement="topLeft"
                                  content={<p>PTE:5 Mil to 10 Mil</p>}
                                >
                                  <Icon
                                    icon="bi:info-circle"
                                    style={{ color: styles.strawberry, marginLeft: 5 }}
                                  />
                                </Popover>
                              </div>
                              <div
                                style={{ margin: "0px 0px", display: "flex", alignItems: "center" }}
                                className="col"
                              >
                                <label style={{ display: "flex" }}>
                                  <input
                                    style={{ margin: "0px 8px" }}
                                    type="radio"
                                    name="radioGroup"
                                    value="GCFO/GCOO"
                                    checked={selectedOption === "GCFO/GCOO"}
                                    onChange={handleOptionChange}
                                  />
                                  GCFO/CFO/CAO/COO
                                </label>
                                <Popover
                                  overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                  placement="topLeft"
                                  content={<p>PTE:(MA Sepang 3 Mil to 5 Mil and UTW,MAN,MASB 1 Mil to 5 Mil) </p>}
                                >
                                  <Icon
                                    icon="bi:info-circle"
                                    style={{ color: styles.strawberry, marginLeft: 5 }}
                                  />
                                </Popover>
                              </div>
                              <div
                                style={{ margin: "0px 0px", display: "flex", alignItems: "center" }}
                                className="col"
                              >
                                <label style={{ display: "flex" }}>
                                  <input
                                    style={{ margin: "0px 8px" }}
                                    type="radio"
                                    name="radioGroup"
                                    value="HeadofSubsidiary"
                                    checked={selectedOption === "HeadofSubsidiary"}
                                    onChange={handleOptionChange}
                                  />
                                  Head of Subsidiary (MA Sepang/MASB/UTW/MAN)
                                </label>
                                <Popover
                                  overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                  placement="topLeft"
                                  content={<p>below 3 Mil, Below 1 Mil(UTW,MAN) </p>}
                                >
                                  <Icon
                                    icon="bi:info-circle"
                                    style={{ color: styles.strawberry, marginLeft: 5 }}
                                  />
                                </Popover>
                              </div>
                              <div
                                style={{ margin: "0px 0px", display: "flex", alignItems: "center" }}
                                className="col"
                              >
                                <label style={{ display: "flex" }}>
                                  <input
                                    style={{ margin: "0px 8px" }}
                                    type="radio"
                                    name="radioGroup"
                                    value="airportManager"
                                    checked={selectedOption === "airportManager"}
                                    onChange={handleOptionChange}
                                  />
                                  Airport Procurement Committee (APC)
                                </label>
                                <Popover
                                  overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                  placement="topLeft"
                                  content={<p>for MASB APC only (Category A 500k and others 150k) </p>}
                                >
                                  <Icon
                                    icon="bi:info-circle"
                                    style={{ color: styles.strawberry, marginLeft: 5 }}
                                  />
                                </Popover>
                              </div>
                            </div>
                          </div>
                          {isSubmitLoading ? (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: 16,
                              }}
                            >
                              <Space size="middle">
                                <Spin size="large" />
                              </Space>
                            </div>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                marginBottom: 16,
                              }}
                            >
                              {
                                <>
                                  <Typography.Title
                                    level={4}
                                    style={{ marginBottom: "25px" }}
                                  >
                                    Budget Manager
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Name the Budget Owner for the Project</p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>
                                  </Typography.Title>

                                  {props.values.signers.map((signer, i) => {
                                    return (
                                      <div
                                        id="budgetManager"
                                        key={`signer${i}`}
                                      >
                                        <Row
                                          gutter={[16, 16]}
                                          align="top"
                                          key={`signer`}
                                        >
                                          <Col span={4}>
                                            <Form.Item label="Designation">
                                              <Field name={`signers[${i}].designation`}>
                                                {({ field }: FieldProps) => (
                                                  <Select
                                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                    showSearch
                                                    value={field.value}
                                                    filterOption={(input, option: any) =>
                                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onBlur={() =>
                                                      props.setFieldTouched(`signers[${i}].designation`, true)
                                                    }
                                                    onChange={(e) => {
                                                      props.setFieldValue(`signers[${i}].designation`, e);
                                                    }}
                                                  >
                                                    {(selectRole === "airportManager"
                                                      ? airportDesignation
                                                      : nonAirportDesignation
                                                    )?.map((item: any) => (
                                                      <Select.Option
                                                        value={item}
                                                        key={item}
                                                      >
                                                        {item}
                                                      </Select.Option>
                                                    ))}
                                                  </Select>
                                                )}
                                              </Field>

                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`signers[${i}].designation`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                          <Col span={4}>
                                            <Form.Item label="Name">
                                              <Field name={`signers[${i}].name`}>
                                                {({ field }: FieldProps) => <Input {...field} />}
                                              </Field>
                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`signers[${i}].name`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                          <Col span={6}>
                                            <Form.Item label="Email">
                                              <Field name={`signers[${i}].email`}>
                                                {({ field }: FieldProps) => <Input {...field} />}
                                              </Field>
                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`signers[${i}].email`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                          <Col span={5}>
                                            <Form.Item label={"Subsidiary/Division"}>
                                              <Field name={`signers[${i}].subsidiary`}>
                                                {({ field }: FieldProps) => (
                                                  <Select
                                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                    showSearch
                                                    value={field.value}
                                                    filterOption={(input, option: any) =>
                                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onBlur={() =>
                                                      props.setFieldTouched(`signers[${i}].subsidiary`, true)
                                                    }
                                                    onChange={(e) => {
                                                      props.setFieldValue(`signers[${i}].subsidiary`, e);
                                                    }}
                                                    status={
                                                      (props.touched.subsidiary &&
                                                        props.errors.subsidiary &&
                                                        "error") ||
                                                      ""
                                                    }
                                                  >
                                                    {subsidiaryData &&
                                                      subsidiaryData.map((values: any) => (
                                                        <Select.Option
                                                          value={`${values.subsidiaryId}/${values.name}`}
                                                          key={values.subsidiaryId}
                                                        >
                                                          {values.name}
                                                        </Select.Option>
                                                      ))}
                                                  </Select>
                                                )}
                                              </Field>
                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`signers[${i}].subsidiary`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                          <Col span={5}>
                                            <Form.Item label={"Cost Centre"}>
                                              <Field name={`signers[${i}].division`}>
                                                {({ field }: FieldProps) => (
                                                  <Select
                                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                    showSearch
                                                    value={field.value}
                                                    filterOption={(input, option: any) =>
                                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onBlur={() => props.setFieldTouched(`signers[${i}].division`, true)}
                                                    onChange={(e) => {
                                                      props.setFieldValue(`signers[${i}].division`, e);
                                                    }}
                                                  >
                                                    {spadivisionData &&
                                                      spadivisionData.map((item: any) => (
                                                        <Select.Option
                                                          value={item.division}
                                                          key={item.uniqueId}
                                                        >
                                                          {item.division}
                                                        </Select.Option>
                                                      ))}
                                                  </Select>
                                                )}
                                              </Field>
                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`signers[${i}].division`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                        </Row>

                                        <Row gutter={16}>
                                          <Col
                                            span={24}
                                            style={{ textAlign: "right", marginBottom: 16, paddingRight: "0px" }}
                                          ></Col>
                                        </Row>
                                      </div>
                                    );
                                  })}
                                </>
                              }

                              {oneCenterEnable && props?.values?.oneCenter?.length > 0 && (
                                <div id="oneStop">
                                  <Typography.Title
                                    level={4}
                                    style={{ marginBottom: "25px" }}
                                  >
                                    Secretariat, PCD
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Applicable for Direct Appointment & Offline Quotation Only </p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>
                                  </Typography.Title>
                                  <div>
                                    {props?.values?.oneCenter?.map((signer, i) => {
                                      return (
                                        <Row
                                          gutter={[24, 24]}
                                          align="top"
                                          key={`signer${i}`}
                                        >
                                          <Col span={6}>
                                            <Form.Item label="Designation">
                                              <Field name={`oneCenter[${i}].designation`}>
                                                {({ field, form }: FieldProps) => (
                                                  <Input
                                                    {...field}
                                                    autoComplete="off"
                                                    readOnly={true}
                                                  />
                                                )}
                                              </Field>
                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`oneCenter[${i}].designation`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                          <Col span={6}>
                                            <Form.Item label="Name">
                                              <Field name={`oneCenter[${i}].name`}>
                                                {({ field }: FieldProps) => (
                                                  <Input
                                                    {...field}
                                                    autoComplete="off"
                                                    readOnly={true}
                                                  />
                                                )}
                                              </Field>
                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`oneCenter[${i}].name`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                          <Col span={6}>
                                            <Form.Item label="Email">
                                              <Field name={`oneCenter[${i}].email`}>
                                                {({ field, form }: FieldProps) => (
                                                  <Input
                                                    {...field}
                                                    autoComplete="off"
                                                    readOnly={true}
                                                  />
                                                )}
                                              </Field>
                                              <Typography.Text type="danger">
                                                <ErrorMessage name={`oneCenter[${i}].email`} />
                                              </Typography.Text>
                                            </Form.Item>
                                          </Col>
                                          {props.values.oneCenter.length > 2 && (
                                            <Col span={2}>
                                              <Form.Item label=" ">
                                                <Button
                                                  type="link"
                                                  danger
                                                  onClick={() => {
                                                    const oneCenter = [...props.values.oneCenter];
                                                    oneCenter.splice(i, 1);
                                                    props.setValues({
                                                      ...props.values,
                                                      oneCenter: oneCenter,
                                                    });
                                                  }}
                                                >
                                                  <Icon
                                                    icon="fluent:delete-16-regular"
                                                    style={{
                                                      color: styles.strawberry,
                                                      cursor: "pointer",
                                                      fontSize: 20,
                                                    }}
                                                  />
                                                </Button>
                                              </Form.Item>
                                            </Col>
                                          )}
                                        </Row>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                              {isAirportManager ? (
                                <>
                                  {" "}
                                  <Typography.Title
                                    level={4}
                                    style={{
                                      marginBottom: styles.whitesapce3,
                                    }}
                                  >
                                    APC Secretariat
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Automated base on Approval Authority Selection </p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>
                                  </Typography.Title>
                                  <div style={{ marginTop: 20 }}>
                                    <Row style={{ display: "block" }}>
                                      {props.values.reviewers.map((_, i) => (
                                        <div key={`{reviewer-${selectRole}-${i}`}>
                                          <Field name={`reviewers[${i}].designation`}>
                                            {({ form }: FieldProps) => {
                                              const selectedDesignation = form.values.reviewers[i]?.designation || "";
                                              const isApc = selectedDesignation === "APC SECRETARIAT";
                                              const currentReviewer = form.values.reviewers[i];
                                              useEffect(() => {
                                                if (reviewersInitialized) return;
                                                const hasNonOneStopCentre = signerDetail?.some(
                                                  (item: any) =>
                                                    item.designation && item.designation !== "One Stop Centre"
                                                );
                                                if (
                                                  envelopId &&
                                                  signerDetail &&
                                                  hasNonOneStopCentre &&
                                                  !isSubmitLoading
                                                ) {
                                                  const mappedReviewers = signerDetail
                                                    .filter(
                                                      (r: any) =>
                                                        r?.designation &&
                                                        !["One Stop Centre", "Manager"].includes(r.designation) &&
                                                        r?.name &&
                                                        r?.emailAddress &&
                                                        r?.reviewingOrder !== undefined &&
                                                        r?.reviewingOrder !== null
                                                    )
                                                    .map((r: any) => ({
                                                      designation: r?.designation,
                                                      name: r?.name,
                                                      email: r?.emailAddress,
                                                      routingOrder: String(r?.reviewingOrder),
                                                      division: r?.division,
                                                      subsidiary: r?.subsidiary,
                                                      status: r?.status,
                                                    }));

                                                  setInitialValues((prev) => ({
                                                    ...prev,
                                                    reviewers: mappedReviewers,
                                                  }));
                                                  setReviewersInitialized(true);
                                                }
                                              }, [
                                                envelopId,
                                                isSubmitLoading,
                                                JSON.stringify(signerDetail),
                                                selectRole,
                                                reviewersInitialized,
                                              ]);

                                              useEffect(() => {
                                                if (isApc) {
                                                  const matchedApcUsers: any[] = approverEmail
                                                    .filter((val: any) => val.designation === "APC SECRETARIAT")
                                                    .map((user: any) => ({
                                                      designation: "APC SECRETARIAT",
                                                      name: user.userName,
                                                      email: user.userEmail,
                                                      routingOrder: "",
                                                    }));

                                                  const nonApcReviewers = form.values.reviewers.filter(
                                                    (r: any) => r.designation !== "APC SECRETARIAT"
                                                  );

                                                  const mergedReviewers = [...matchedApcUsers, ...nonApcReviewers];

                                                  const currentApcCount = form.values.reviewers.filter(
                                                    (r: any) => r.designation === "APC SECRETARIAT"
                                                  ).length;
                                                  const expectedApcCount = matchedApcUsers.length;

                                                  if (currentApcCount !== expectedApcCount) {
                                                    form.setFieldValue("reviewers", mergedReviewers);
                                                  }
                                                }
                                              }, [
                                                isApc,
                                                selectRole,
                                                isSubmitLoading,
                                                JSON.stringify(approverEmail),
                                                JSON.stringify(form.values.reviewers),
                                              ]);

                                              return isApc && currentReviewer ? (
                                                <Row
                                                  gutter={16}
                                                  key={`r1-${i}`}
                                                >
                                                  <Col span={5}>
                                                    <Form.Item label="Designation">
                                                      <Input
                                                        disabled
                                                        value={currentReviewer.designation}
                                                        autoComplete="off"
                                                      />
                                                    </Form.Item>
                                                  </Col>

                                                  <Col span={9}>
                                                    <Form.Item label="Name">
                                                      <Tooltip title={currentReviewer.name}>
                                                        <Input
                                                          readOnly
                                                          value={currentReviewer.name}
                                                        />
                                                      </Tooltip>
                                                    </Form.Item>
                                                  </Col>

                                                  <Col span={9}>
                                                    <Form.Item label="Email">
                                                      <Tooltip title={currentReviewer.email}>
                                                        <Input
                                                          readOnly
                                                          value={currentReviewer.email}
                                                        />
                                                      </Tooltip>
                                                    </Form.Item>
                                                  </Col>
                                                </Row>
                                              ) : null;
                                            }}
                                          </Field>
                                        </div>
                                      ))}
                                    </Row>
                                  </div>
                                  <Typography.Title
                                    level={4}
                                    style={{
                                      marginBottom: styles.whitesapce3,
                                    }}
                                  >
                                    APC Members
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Automated base on Approval Authority Selection </p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>
                                  </Typography.Title>
                                  <Row style={{ display: "block" }}>
                                    {props.values.reviewers.map((_, i) => (
                                      <div key={`{reviewer-${selectRole}-${i}`}>
                                        <Field name={`reviewers[${i}].designation`}>
                                          {({ form }: FieldProps) => {
                                            const selectedDesignation = form.values.reviewers[i]?.designation || "";
                                            const isApc = selectedDesignation === "APC MEMBER";
                                            const currentReviewer = form.values.reviewers[i];
                                            useEffect(() => {
                                              if (reviewersInitialized) return;
                                              const hasNonOneStopCentre = signerDetail?.some(
                                                (item: any) =>
                                                  item.designation && item.designation !== "One Stop Centre"
                                              );
                                              if (
                                                envelopId &&
                                                signerDetail &&
                                                hasNonOneStopCentre &&
                                                !isSubmitLoading
                                              ) {
                                                const mappedReviewers = signerDetail
                                                  .filter(
                                                    (r: any) =>
                                                      r?.designation &&
                                                      !["One Stop Centre", "Manager"].includes(r.designation) &&
                                                      r?.name &&
                                                      r?.emailAddress &&
                                                      r?.reviewingOrder !== undefined &&
                                                      r?.reviewingOrder !== null
                                                  )
                                                  .map((r: any) => ({
                                                    designation: r?.designation,
                                                    name: r?.name,
                                                    email: r?.emailAddress,
                                                    routingOrder: String(r?.reviewingOrder),
                                                    division: r?.division,
                                                    subsidiary: r?.subsidiary,
                                                    status: r?.status,
                                                  }));

                                                setInitialValues((prev) => ({
                                                  ...prev,
                                                  reviewers: mappedReviewers,
                                                }));
                                                setReviewersInitialized(true);
                                              }
                                            }, [
                                              envelopId,
                                              isSubmitLoading,
                                              JSON.stringify(signerDetail),
                                              selectRole,
                                              reviewersInitialized,
                                            ]);

                                            useEffect(() => {
                                              if (isApc) {
                                                const matchedApcUsers: any[] = approverEmail
                                                  .filter((val: any) => val.designation === "APC MEMBER")
                                                  .map((user: any) => ({
                                                    designation: "APC MEMBER",
                                                    name: user.userName,
                                                    email: user.userEmail,
                                                    routingOrder: "",
                                                  }));

                                                const nonApcReviewers = form.values.reviewers.filter(
                                                  (r: any) => r.designation !== "APC MEMBER"
                                                );

                                                const mergedReviewers = [...matchedApcUsers, ...nonApcReviewers];

                                                const currentApcCount = form.values.reviewers.filter(
                                                  (r: any) => r.designation === "APC MEMBER"
                                                ).length;
                                                const expectedApcCount = matchedApcUsers.length;

                                                if (currentApcCount !== expectedApcCount) {
                                                  form.setFieldValue("reviewers", mergedReviewers);
                                                }
                                              }
                                            }, [
                                              isApc,
                                              selectRole,
                                              isSubmitLoading,
                                              JSON.stringify(approverEmail),
                                              JSON.stringify(form.values.reviewers),
                                            ]);

                                            return isApc && currentReviewer ? (
                                              <Row
                                                gutter={16}
                                                key={`r1-${i}`}
                                              >
                                                <Col span={5}>
                                                  <Form.Item label="Designation">
                                                    <Input
                                                      disabled
                                                      value={currentReviewer.designation}
                                                      autoComplete="off"
                                                    />
                                                  </Form.Item>
                                                </Col>

                                                <Col span={9}>
                                                  <Form.Item label="Name">
                                                    <Tooltip title={currentReviewer.name}>
                                                      <Input
                                                        readOnly
                                                        value={currentReviewer.name}
                                                      />
                                                    </Tooltip>
                                                  </Form.Item>
                                                </Col>

                                                <Col span={9}>
                                                  <Form.Item label="Email">
                                                    <Tooltip title={currentReviewer.email}>
                                                      <Input
                                                        readOnly
                                                        value={currentReviewer.email}
                                                      />
                                                    </Tooltip>
                                                  </Form.Item>
                                                </Col>
                                              </Row>
                                            ) : null;
                                          }}
                                        </Field>
                                      </div>
                                    ))}
                                  </Row>
                                  <Typography.Title
                                    level={4}
                                    style={{
                                      marginBottom: styles.whitesapce3,
                                    }}
                                  >
                                    Airport Manager
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Automated base on Approval Authority Selection </p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>
                                  </Typography.Title>
                                  <Row style={{ display: "block" }}>
                                    {!approverError &&
                                      props.values.reviewers.map((_, i) => (
                                        <div key={`{reviewer-${selectRole}-${i}`}>
                                          <Field name={`reviewers[${i}].designation`}>
                                            {({ form }: FieldProps) => {
                                              const selectedDesignation = form.values.reviewers[i]?.designation || "";
                                              const isR1 = selectedDesignation === "APC MEMBER";
                                              const isApc = selectedDesignation === "APC SECRETARIAT";
                                              return !isR1 && !isApc ? (
                                                <Row gutter={16}>
                                                  <Col span={5}>
                                                    <Form.Item label="Designation">
                                                      <Field name={`reviewers[${i}].designation`}>
                                                        {({ field, form }: FieldProps) => {
                                                          const mdOrGceo = ["MD", "GCEO"].some((designation) =>
                                                            approverDesignation.includes(designation)
                                                          );
                                                          const cooOrGcf = ["COO", "GCFO", "GCOO"].some((designation) =>
                                                            approverDesignation.includes(designation)
                                                          );
                                                          const optionalDsgn = mdOrGceo
                                                            ? ["MD", "GCEO"].filter((designation) =>
                                                              approverDesignation.includes(designation)
                                                            )
                                                            : cooOrGcf
                                                              ? ["COO", "GCFO", "GCOO"].filter((designation) =>
                                                                approverDesignation.includes(designation)
                                                              )
                                                              : approverDesignation;
                                                          const isLastIndex =
                                                            i ===
                                                            (mdOrGceo
                                                              ? approverDesignation.length -
                                                              (approverDesignation.length === 4 ? 2 : 1)
                                                              : cooOrGcf
                                                                ? approverDesignation.length -
                                                                (approverDesignation.length === 4
                                                                  ? 3
                                                                  : approverDesignation.length === 3
                                                                    ? 2
                                                                    : 1)
                                                                : "");
                                                          return (
                                                            <>
                                                              {isLastIndex ? (
                                                                <Select
                                                                  getPopupContainer={(triggerNode) =>
                                                                    triggerNode.parentNode
                                                                  }
                                                                  {...field}
                                                                  showSearch
                                                                  style={{ width: "100%" }}
                                                                  placeholder="Select a designation"
                                                                  onChange={(value) => {
                                                                    form.setFieldValue(
                                                                      `reviewers[${i}].designation`,
                                                                      value
                                                                    );
                                                                    const matched: any = approverEmail.find(
                                                                      (val: any) => val.designation === value
                                                                    );
                                                                    form.setFieldValue(
                                                                      `reviewers[${i}].name`,
                                                                      matched?.userName || ""
                                                                    );
                                                                    form.setFieldValue(
                                                                      `reviewers[${i}].email`,
                                                                      matched?.userEmail || ""
                                                                    );
                                                                  }}
                                                                >
                                                                  {optionalDsgn.map((user: any) => (
                                                                    <Select.Option
                                                                      key={user}
                                                                      value={user}
                                                                    >
                                                                      {user}
                                                                    </Select.Option>
                                                                  ))}
                                                                </Select>
                                                              ) : (
                                                                <Input
                                                                  disabled
                                                                  {...field}
                                                                  value={form.values.reviewers[i]?.designation}
                                                                  autoComplete="off"
                                                                />
                                                              )}
                                                            </>
                                                          );
                                                        }}
                                                      </Field>
                                                      <Typography.Text type="danger">
                                                        <ErrorMessage name={`reviewers[${i}].designation`} />
                                                      </Typography.Text>
                                                    </Form.Item>
                                                  </Col>

                                                  <Col span={9}>
                                                    <Form.Item label="Name">
                                                      <Field name={`reviewers[${i}].name`}>
                                                        {({ field, form }: FieldProps) => {
                                                          const matchedNames = approverEmail.filter(
                                                            (val: any) => val.designation === selectedDesignation
                                                          );
                                                          const uniqueMatchedNames = matchedNames.reduce(
                                                            (acc: any[], curr: any) => {
                                                              if (
                                                                !acc.some((item) => item.userEmail === curr.userEmail)
                                                              ) {
                                                                acc.push(curr);
                                                              }
                                                              return acc;
                                                            },
                                                            []
                                                          );

                                                          return (
                                                            <Select
                                                              {...field}
                                                              showSearch
                                                              style={{ width: "100%" }}
                                                              placeholder="Select a name"
                                                              onChange={(value, option: any) => {
                                                                form.setFieldValue(`reviewers[${i}].name`, value);
                                                                form.setFieldValue(
                                                                  `reviewers[${i}].email`,
                                                                  option?.label || ""
                                                                );
                                                              }}
                                                            >
                                                              {uniqueMatchedNames.map((user: any, index: any) => (
                                                                <Select.Option
                                                                  key={index}
                                                                  value={user.userName || user.name}
                                                                  label={user.userEmail || user.email}
                                                                >
                                                                  {user.userName || user.name}
                                                                </Select.Option>
                                                              ))}
                                                            </Select>
                                                          );
                                                        }}
                                                      </Field>
                                                      <Typography.Text type="danger">
                                                        <ErrorMessage name={`reviewers[${i}].name`} />
                                                      </Typography.Text>
                                                    </Form.Item>
                                                  </Col>

                                                  <Col span={9}>
                                                    <Form.Item label="Email">
                                                      <Field name={`reviewers[${i}].email`}>
                                                        {({ field, form }: FieldProps) => {
                                                          const matchedEmails = approverEmail.filter(
                                                            (val: any) => val.designation === selectedDesignation
                                                          );
                                                          const uniqueMatchedEmails = matchedEmails.reduce(
                                                            (acc: any[], curr: any) => {
                                                              if (
                                                                !acc.some((item) => item.userName === curr.userName)
                                                              ) {
                                                                acc.push(curr);
                                                              }
                                                              return acc;
                                                            },
                                                            []
                                                          );

                                                          return (
                                                            <Select
                                                              {...field}
                                                              showSearch
                                                              style={{ width: "100%" }}
                                                              placeholder="Select an email"
                                                              onChange={(value, option: any) => {
                                                                form.setFieldValue(`reviewers[${i}].email`, value);
                                                                form.setFieldValue(
                                                                  `reviewers[${i}].name`,
                                                                  option?.label || ""
                                                                );
                                                              }}
                                                            >
                                                              {uniqueMatchedEmails.map((email: any, index: any) => (
                                                                <Select.Option
                                                                  key={index}
                                                                  value={email.userEmail || email.email}
                                                                  label={email.userName || email.name}
                                                                >
                                                                  {email.userEmail || email.email}
                                                                </Select.Option>
                                                              ))}
                                                            </Select>
                                                          );
                                                        }}
                                                      </Field>
                                                      <Typography.Text type="danger">
                                                        <ErrorMessage name={`reviewers[${i}].email`} />
                                                      </Typography.Text>
                                                    </Form.Item>
                                                  </Col>
                                                </Row>
                                              ) : null;
                                            }}
                                          </Field>
                                        </div>
                                      ))}
                                  </Row>
                                </>
                              ) : (
                                <div>
                                  <Typography.Title
                                    level={4}
                                    style={{
                                      marginBottom: styles.whitesapce3,
                                    }}
                                  >
                                    Approvers Details
                                    <Popover
                                      overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                      placement="topLeft"
                                      content={<p>Automated base on Approval Authority Selection </p>}
                                    >
                                      <Icon
                                        icon="bi:info-circle"
                                        style={{ color: styles.strawberry, marginLeft: 5 }}
                                      />
                                    </Popover>
                                  </Typography.Title>
                                  <>
                                    <Row style={{ display: "block" }}>
                                      {!approverError &&
                                        props.values.reviewers.map((_, i) => (
                                          <div key={`{reviewer-${selectRole}-${i}`}>
                                            <Field name={`reviewers[${i}].designation`}>
                                              {({ form }: FieldProps) => {
                                                const selectedDesignation = form.values.reviewers[i]?.designation || "";
                                                const isR1 = selectedDesignation === "R1";
                                                const isApc = selectedDesignation === "APC SECRETARIAT";
                                                const currentReviewer = form.values.reviewers[i];
                                                useEffect(() => {
                                                  if (reviewersInitialized) return;
                                                  const hasNonOneStopCentre = signerDetail?.some(
                                                    (item: any) =>
                                                      item.designation && item.designation !== "One Stop Centre"
                                                  );
                                                  if (
                                                    envelopId &&
                                                    signerDetail &&
                                                    hasNonOneStopCentre &&
                                                    !isSubmitLoading
                                                  ) {
                                                    const mappedReviewers = signerDetail
                                                      .filter(
                                                        (r: any) =>
                                                          r?.designation &&
                                                          !["One Stop Centre", "Manager"].includes(r.designation) &&
                                                          r?.name &&
                                                          r?.emailAddress &&
                                                          r?.reviewingOrder !== undefined &&
                                                          r?.reviewingOrder !== null
                                                      )
                                                      .map((r: any) => ({
                                                        designation: r?.designation,
                                                        name: r?.name,
                                                        email: r?.emailAddress,
                                                        routingOrder: String(r?.reviewingOrder),
                                                        division: r?.division,
                                                        subsidiary: r?.subsidiary,
                                                        status: r?.status,
                                                      }));

                                                    setInitialValues((prev) => ({
                                                      ...prev,
                                                      reviewers: mappedReviewers,
                                                    }));
                                                    setReviewersInitialized(true);
                                                  }
                                                }, [
                                                  envelopId,
                                                  isSubmitLoading,
                                                  JSON.stringify(signerDetail),
                                                  selectRole,
                                                  reviewersInitialized,
                                                ]);

                                                useEffect(() => {
                                                  if (isR1) {
                                                    const specialDesignations = ["R1"];

                                                    const matchedSpecialUsers: any[] = approverEmail
                                                      .filter(
                                                        (val: any) =>
                                                          specialDesignations.includes(val.designation) &&
                                                          val.userName &&
                                                          val.userEmail
                                                      )
                                                      .map((user: any) => ({
                                                        designation: user.designation,
                                                        name: user.userName,
                                                        email: user.userEmail,
                                                        routingOrder: "",
                                                      }));

                                                    const nonSpecialReviewers = form?.values?.reviewers
                                                      .filter((r: any) => !specialDesignations.includes(r?.designation))
                                                      .map((r: any, index: number) => ({
                                                        ...r,
                                                        routingOrder: String(index + 2),
                                                      }));

                                                    const mergedReviewers = [
                                                      ...matchedSpecialUsers,
                                                      ...nonSpecialReviewers,
                                                    ];

                                                    const currentSpecialCount = form?.values?.reviewers.filter(
                                                      (r: any) => specialDesignations.includes(r?.designation)
                                                    ).length;
                                                    const expectedSpecialCount = matchedSpecialUsers.length;

                                                    if (currentSpecialCount !== expectedSpecialCount) {
                                                      form.setFieldValue("reviewers", mergedReviewers);
                                                    }
                                                  }

                                                  if (isApc) {
                                                    const matchedApcUsers: any[] = approverEmail
                                                      .filter((val: any) => val.designation === "APC SECRETARIAT")
                                                      .map((user: any) => ({
                                                        designation: "APC SECRETARIAT",
                                                        name: user.userName,
                                                        email: user.userEmail,
                                                        routingOrder: "",
                                                      }));

                                                    const nonApcReviewers = form.values.reviewers.filter(
                                                      (r: any) => r.designation !== "APC SECRETARIAT"
                                                    );

                                                    const mergedReviewers = [...matchedApcUsers, ...nonApcReviewers];

                                                    const currentApcCount = form.values.reviewers.filter(
                                                      (r: any) => r.designation === "APC SECRETARIAT"
                                                    ).length;
                                                    const expectedApcCount = matchedApcUsers.length;

                                                    if (currentApcCount !== expectedApcCount) {
                                                      form.setFieldValue("reviewers", mergedReviewers);
                                                    }
                                                  }
                                                }, [
                                                  isR1,
                                                  isApc,
                                                  selectRole,
                                                  isSubmitLoading,
                                                  JSON.stringify(approverEmail),
                                                  JSON.stringify(form.values.reviewers),
                                                ]);

                                                return (isR1 || isApc) && currentReviewer ? (
                                                  <Row
                                                    gutter={16}
                                                    key={`r1-${i}`}
                                                  >
                                                    <Col span={5}>
                                                      <Form.Item label="Designation">
                                                        <Input
                                                          disabled
                                                          value={currentReviewer.designation}
                                                          autoComplete="off"
                                                        />
                                                      </Form.Item>
                                                    </Col>

                                                    <Col span={9}>
                                                      <Form.Item label="Name">
                                                        <Tooltip title={currentReviewer.name}>
                                                          <Input
                                                            readOnly
                                                            value={currentReviewer.name}
                                                          />
                                                        </Tooltip>
                                                      </Form.Item>
                                                    </Col>

                                                    <Col span={9}>
                                                      <Form.Item label="Email">
                                                        <Tooltip title={currentReviewer.email}>
                                                          <Input
                                                            readOnly
                                                            value={currentReviewer.email}
                                                          />
                                                        </Tooltip>
                                                      </Form.Item>
                                                    </Col>
                                                  </Row>
                                                ) : null;
                                              }}
                                            </Field>
                                            <Field name={`reviewers[${i}].designation`}>
                                              {({ form }: FieldProps) => {
                                                const selectedDesignation = form.values.reviewers[i]?.designation || "";
                                                const isR1 = selectedDesignation === "R1";
                                                const isApc = selectedDesignation === "APC SECRETARIAT";
                                                return !isR1 && !isApc ? (
                                                  <Row gutter={16}>
                                                    <Col span={5}>
                                                      <Form.Item label="Designation">
                                                        <Field name={`reviewers[${i}].designation`}>
                                                          {({ field, form }: FieldProps) => {
                                                            const mdOrGceo = ["MD", "GCEO"].some((designation) =>
                                                              approverDesignation.includes(designation)
                                                            );
                                                            const cooOrGcf = ["COO", "GCFO", "GCOO"];
                                                            const approverDesignations = approverData.map(
                                                              (d: any) => d.designation
                                                            );
                                                            const optionalDsgn = mdOrGceo
                                                              ? ["MD", "GCEO"].filter((designation) =>
                                                                approverDesignation.includes(designation)
                                                              )
                                                              : cooOrGcf
                                                                ? ["COO", "GCFO", "GCOO", "CAO", "CFO"]
                                                                : approverDesignation;
                                                            const isLastIndex =
                                                              i ===
                                                              (mdOrGceo
                                                                ? approverDesignation.length -
                                                                (approverDesignation.length === 4 ? 2 : 1)
                                                                : cooOrGcf
                                                                  ? approverDesignation.length -
                                                                  (approverDesignation.length === 4
                                                                    ? 3
                                                                    : approverDesignation.length === 3
                                                                      ? 2
                                                                      : 1)
                                                                  : "");
                                                            return (
                                                              <>
                                                                {selectRole === "GCFO/GCOO" ? (
                                                                  <Select
                                                                    getPopupContainer={(triggerNode) =>
                                                                      triggerNode.parentNode
                                                                    }
                                                                    {...field}
                                                                    disabled={field.value === "R2"}
                                                                    showSearch
                                                                    style={{ width: "100%" }}
                                                                    placeholder="Select a designation"
                                                                    onChange={(value) => {
                                                                      form.setFieldValue(
                                                                        `reviewers[${i}].designation`,
                                                                        value
                                                                      );
                                                                      const matched: any = approverEmail.find(
                                                                        (val: any) => val.designation === value
                                                                      );
                                                                      form.setFieldValue(
                                                                        `reviewers[${i}].name`,
                                                                        matched?.userName || ""
                                                                      );
                                                                      form.setFieldValue(
                                                                        `reviewers[${i}].email`,
                                                                        matched?.userEmail || ""
                                                                      );
                                                                    }}
                                                                  >
                                                                    {optionalDsgn.map((user: any) => (
                                                                      <Select.Option
                                                                        key={user}
                                                                        value={user}
                                                                      >
                                                                        {user}
                                                                      </Select.Option>
                                                                    ))}
                                                                  </Select>
                                                                ) : (
                                                                  <Input
                                                                    disabled
                                                                    {...field}
                                                                    value={form.values.reviewers[i]?.designation}
                                                                    autoComplete="off"
                                                                  />
                                                                )}
                                                              </>
                                                            );
                                                          }}
                                                        </Field>
                                                        <Typography.Text type="danger">
                                                          <ErrorMessage name={`reviewers[${i}].designation`} />
                                                        </Typography.Text>
                                                      </Form.Item>
                                                    </Col>

                                                    <Col span={9}>
                                                      <Form.Item label="Name">
                                                        <Field name={`reviewers[${i}].name`}>
                                                          {({ field, form }: FieldProps) => {
                                                            const matchedNames = approverEmail.filter(
                                                              (val: any) => val.designation === selectedDesignation
                                                            );
                                                            const uniqueMatchedNames = matchedNames.reduce(
                                                              (acc: any[], curr: any) => {
                                                                if (
                                                                  !acc.some((item) => item.userEmail === curr.userEmail)
                                                                ) {
                                                                  acc.push(curr);
                                                                }
                                                                return acc;
                                                              },
                                                              []
                                                            );

                                                            return (
                                                              <Select
                                                                {...field}
                                                                showSearch
                                                                style={{ width: "100%" }}
                                                                placeholder="Select a name"
                                                                onChange={(value, option: any) => {
                                                                  form.setFieldValue(`reviewers[${i}].name`, value);
                                                                  form.setFieldValue(
                                                                    `reviewers[${i}].email`,
                                                                    option?.label || ""
                                                                  );
                                                                }}
                                                              >
                                                                {uniqueMatchedNames.map((user: any, index: any) => (
                                                                  <Select.Option
                                                                    key={index}
                                                                    value={user.userName || user.name}
                                                                    label={user.userEmail || user.email}
                                                                  >
                                                                    {user.userName || user.name}
                                                                  </Select.Option>
                                                                ))}
                                                              </Select>
                                                            );
                                                          }}
                                                        </Field>
                                                        <Typography.Text type="danger">
                                                          <ErrorMessage name={`reviewers[${i}].name`} />
                                                        </Typography.Text>
                                                      </Form.Item>
                                                    </Col>

                                                    <Col span={9}>
                                                      <Form.Item label="Email">
                                                        <Field name={`reviewers[${i}].email`}>
                                                          {({ field, form }: FieldProps) => {
                                                            const matchedEmails = approverEmail.filter(
                                                              (val: any) => val.designation === selectedDesignation
                                                            );
                                                            const uniqueMatchedEmails = matchedEmails.reduce(
                                                              (acc: any[], curr: any) => {
                                                                if (
                                                                  !acc.some((item) => item.userName === curr.userName)
                                                                ) {
                                                                  acc.push(curr);
                                                                }
                                                                return acc;
                                                              },
                                                              []
                                                            );

                                                            return (
                                                              <Select
                                                                {...field}
                                                                showSearch
                                                                style={{ width: "100%" }}
                                                                placeholder="Select an email"
                                                                onChange={(value, option: any) => {
                                                                  form.setFieldValue(`reviewers[${i}].email`, value);
                                                                  form.setFieldValue(
                                                                    `reviewers[${i}].name`,
                                                                    option?.label || ""
                                                                  );
                                                                }}
                                                              >
                                                                {uniqueMatchedEmails.map((email: any, index: any) => (
                                                                  <Select.Option
                                                                    key={index}
                                                                    value={email.userEmail || email.email}
                                                                    label={email.userName || email.name}
                                                                  >
                                                                    {email.userEmail || email.email}
                                                                  </Select.Option>
                                                                ))}
                                                              </Select>
                                                            );
                                                          }}
                                                        </Field>
                                                        <Typography.Text type="danger">
                                                          <ErrorMessage name={`reviewers[${i}].email`} />
                                                        </Typography.Text>
                                                      </Form.Item>
                                                    </Col>
                                                  </Row>
                                                ) : null;
                                              }}
                                            </Field>
                                          </div>
                                        ))}
                                    </Row>
                                  </>
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div>
                      {currentStep === 3 && (
                        <>
                          <div
                            style={{
                              width: "100%",
                              marginBottom: 16,
                            }}
                          >
                            <Typography.Title
                              level={4}
                              style={{ marginBottom: styles.whitesapce3 }}
                            >
                              Watchers Details
                              <Popover
                                overlayInnerStyle={{ maxWidth: 450, width: 450 }}
                                placement="topLeft"
                                content={<p>Input name and email address to receive copy of SPA</p>}
                              >
                                <Icon
                                  icon="bi:info-circle"
                                  style={{ color: styles.strawberry, marginLeft: 5 }}
                                />
                              </Popover>
                            </Typography.Title>
                            {props.values.watchers.map((signer, i) => {
                              const pcdEndIndex = watcherList.length;
                              const technicalIndex = watcherList.length + 1;
                              const isOthers = i > technicalIndex;
                              const isReadOnly = i >= 1 && i <= pcdEndIndex;

                              return (
                                <Row
                                  style={{ position: "relative" }}
                                  gutter={16}
                                  align="top"
                                  key={`watcher${i}`}
                                >
                                  <Col span={5}>
                                    <Form.Item label="Reviewer">
                                      <Field name={`watchers[${i}].role`}>
                                        {({ field }: FieldProps) => (
                                          <Input
                                            disabled={true}
                                            {...field}
                                            value={
                                              i === 0
                                                ? "Finance"
                                                : i >= 1 && i <= pcdEndIndex
                                                  ? "PCD"
                                                  : i === technicalIndex
                                                    ? "Technical"
                                                    : "Others"
                                            }
                                            autoComplete="off"
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`watchers[${i}].role`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>

                                  <Col span={9}>
                                    <Form.Item label="Name">
                                      <Field name={`watchers[${i}].userName`}>
                                        {({ field }: FieldProps) => (
                                          <Input
                                            {...field}
                                            readOnly={isReadOnly}
                                            autoComplete="off"
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`watchers[${i}].userName`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>

                                  <Col span={9}>
                                    <Form.Item label="Email">
                                      <Field name={`watchers[${i}].userEmail`}>
                                        {({ field }: FieldProps) => (
                                          <Input
                                            {...field}
                                            readOnly={isReadOnly}
                                            autoComplete="off"
                                          />
                                        )}
                                      </Field>
                                      <Typography.Text type="danger">
                                        <ErrorMessage name={`watchers[${i}].userEmail`} />
                                      </Typography.Text>
                                    </Form.Item>
                                  </Col>
                                  {isOthers && (
                                    <div style={{ position: "absolute", right: "0px", top: "0px" }}>
                                      <Form.Item label=" ">
                                        <Button
                                          type="link"
                                          danger
                                          disabled={props.values.watchers.length === 1}
                                          onClick={() => {
                                            props.setValues((prevValues) => ({
                                              ...prevValues,
                                              watchers: prevValues.watchers.filter((_, index) => index !== i),
                                            }));
                                          }}
                                        >
                                          <Icon
                                            icon="fluent:delete-16-regular"
                                            style={{ color: styles.strawberry, cursor: "pointer", fontSize: 20 }}
                                          />
                                        </Button>
                                      </Form.Item>
                                    </div>
                                  )}
                                </Row>
                              );
                            })}

                            <Row>
                              <Col
                                span={24}
                                style={{ textAlign: "right", marginBottom: 16 }}
                              >
                                <Button
                                  type="text"
                                  icon={<Icon icon="akar-icons:plus" />}
                                  onClick={() => {
                                    let watchers = [
                                      ...props?.values?.watchers,
                                      {
                                        userName: "",
                                        userEmail: "",
                                        role: props.values.watchers.length >= 3 ? "Others" : "",
                                      },
                                    ];
                                    props.setValues((prevValues) => ({
                                      ...prevValues,
                                      watchers: [...prevValues.watchers, { userName: "", userEmail: "", role: "" }],
                                    }));

                                    setTimeout(() => {
                                      let index = watchers?.length - 1;
                                      props.setFieldTouched(`watchers[${index}].userName`, false);
                                      props.setFieldTouched(`watchers[${index}].userEmail`, false);
                                    }, 0);
                                  }}
                                >
                                  Add Watcher
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        </>
                      )}
                    </div>
                    <div id="step1">
                      {currentStep === 4 && (
                        <>
                          <SpaReviewForm
                            selectedAuthority={selectRole}
                            cost={costValue}
                            props={props}
                            getItemText={getItemText}
                            step1Function={step1Function}
                            step2Function={step2Function}
                            docsList={docsList}
                            viewDocument={viewDocument}
                            stepAdditionalDocFunction={stepAdditionalDocFunction}
                            stepBudgetFunction={stepBudgetFunction}
                            oneCenterEnable={oneCenterEnable}
                            stepOneStopFunction={stepOneStopFunction}
                            stepApproverFunction={stepApproverFunction}
                            sortedWatchers={sortedWatchers}
                            stepWatcherFunction={stepWatcherFunction}
                            subsidiaryName={subsidiaryName}
                            selectedPoints={selectedPoints}
                          />
                        </>
                      )}
                    </div>
                    {isSubmitLoading ? null : (
                      <Row>
                        <Col
                          xs={24}
                          md={24}
                          style={{ textAlign: "right" }}
                        >
                          {currentStep === 4 && (
                            <Space>
                              <Button
                                type="default"
                                onClick={() => {
                                  setCurrentStep((current) => current - 1);
                                }}
                              >
                                Back
                              </Button>
                              <Button
                                htmlType="submit"
                                type="primary"
                                loading={isSubmitLoading}
                              >
                                Submit
                              </Button>
                            </Space>
                          )}
                          {currentStep < 4 && (
                            <Space>
                              {currentStep > 0 && (
                                <Button
                                  type="default"
                                  disabled={currentStep === 0}
                                  onClick={() => {
                                    if (currentStep === 2) {
                                      props.setFieldValue("signers", defaultValue.signers);
                                      props.setFieldValue("reviewers", defaultValue.reviewers);
                                      props.setFieldValue("oneCenter", defaultValue.oneCenter);
                                    }
                                    setCurrentStep((current) => current - 1);
                                    scrollToElement("step1");
                                  }}
                                >
                                  Back
                                </Button>
                              )}
                              {(displaySave || props?.values.status === "draft") && (
                                <Button
                                  onClick={() => {
                                    saveAsDraft(props.values);
                                    setIsDraftSaved(true);
                                  }}
                                  disabled={
                                    (currentStep === 2 && isApproverApiFailed) ||
                                    (!envelopId && !hasAnyFieldFilled(props.values, docsList, currentStep))
                                  }
                                  loading={isloading}
                                >
                                  Save as Draft
                                </Button>
                              )}
                              <Button
                                type="primary"
                                disabled={
                                  (approverError && currentStep === 2) ||
                                  !selectedPoints ||
                                  (currentStep === 1 && (!docsList || docsList.length === 0)) ||
                                  (currentStep !== 1 &&
                                    !(props?.isValid && (props?.dirty || hasFilledRequiredFields(props?.values)))) ||
                                  (currentStep === 2 &&
                                    !isAirportManager &&
                                    (!props?.values?.signers[0]?.name || !props?.values?.reviewers[0]?.name))
                                }
                                onClick={() => {
                                  setCurrentStep((current) => current + 1);
                                  scrollToElement("step1");
                                }}
                              >
                                Next
                              </Button>
                            </Space>
                          )}
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        <LoaderModal
          isOpenModal={loaderModal}
          filesUploadCount={filesUploadedCount}
          totalFiles={totalFiles}
          redirect={`/spa`}
          isRearrangeable={false}
          envelopeId={id}
        />
      </ContentWrapper>
    </>
  );
};
